// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:27:31.097Z
// Property: Watersedge (ID: 5198384616964096)
// Collections: 18 amenities, 14 floorplans (live), 26 photos, 79 POIs, 5 reviews, 7 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5198384616964096",
  "property_external_id": "5056167",
  "property_zillow_url": "https://www.zillow.com/apartments/webster-tx/1799-fm-528/5XhsMC/",
  "property_apartments_url": "https://www.apartments.com/watersedge-webster-tx/vpnf10f",
  "property_google_business_url": "https://www.google.com/maps/place/Watersedge/data=!4m2!3m1!1s0x0:0x829bad56e67260f7?sa=X&ved=2ahUKEwjP2pPv1rySAxXXITQIHeu6B58Q_BJ6BAg8EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "9835702688",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "watersedge",
  "property_name": "Watersedge",
  "property_website_url": "https://www.lifeatwatersedge.com/",
  "property_domain": "https://www.lifeatwatersedge.com/",
  "property_address": "1799 Fm 528 Rd",
  "property_full_address": "1799 FM 528 Rd, Webster, TX 77598",
  "property_address_1": "1799 FM 528 Rd",
  "property_address_2": null,
  "property_address_city": "Webster",
  "property_address_state": "TX",
  "property_address_zip_full": "77598-4710",
  "property_address_zip": "77598",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Webster",
  "property_address_latitude": "29.5227947",
  "property_address_longitude": "-95.14046689999999",
  "property_email": "watersedge@alapts.com",
  "property_phone": "(281) 554-4333",
  "property_call_tracking_phone": "832-779-4659",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Lake-view living made easy in Webster.</strong> Settle into a one- or two-bedroom apartment with calm trails, lighted fountains, and inviting home finishes, then explore <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Watersedge in person.</p>",
  "property_long_description": "<p><strong>Lake-view living in the heart of Webster.</strong> At Watersedge, you can settle into a one- or two-bedroom apartment surrounded by walking trails, lighted fountains, and everyday conveniences that make home feel calm and connected. Choose layouts with inviting details like sunrooms, private patios or balconies, oversized closets, vaulted ceilings, full-size washers and dryers, custom cabinetry, quartz bathroom countertops, and select stainless-steel appliances.</p><p>Beyond your front door, <a href=\"/amenities\">community amenities</a> bring the best of the property together: two resort-inspired pools, a 24-hour fitness studio, picnic areas with grilling stations, package lockers, controlled access, EV charging, and a spacious bark park. When you’re ready to explore, FM 528/West NASA Parkway keeps you close to I-45, Baybrook Mall dining and shopping, Webster Town Center, Space Center Houston, NASA Johnson Space Center, Clear Lake, and the nature trails and boardwalks at Challenger 7 Memorial Park. Browse the <a href=\"/floor-plans\">floor plans</a> or schedule a tour to see Watersedge in person.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-3536-716a-ade5-fe3823d7d81a.webp",
  "property_featured_image_media": {
    "alt_text": "Luxury swimming pool with lounge chairs and umbrellas next to a residential building.",
    "public_id": "019d02ee-3536-716a-ade5-fe3823d7d81a",
    "storage_key": "property/5198384616964096/019d02ee-3536-716a-ade5-fe3823d7d81a.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "354",
  "property_year_built": "2008",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.35028248587571",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Administrative Fee $150\n\nApplication Fee $75 per person\n\nApplication Approval Fee $150",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 for your 1st pet and an additional $200 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 for your 1st pet and an additional $200 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "http://8943837.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://watersedgealm.loftliving.com/login",
  "property_apply_now_url": "http://8943837.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ed-d944-73ef-8c0e-de89e7cdb749.webp",
  "property_primary_logo_media": {
    "alt_text": "Watersedge Webster Texas logo",
    "public_id": "019d02ed-d944-73ef-8c0e-de89e7cdb749",
    "storage_key": "property/5198384616964096/019d02ed-d944-73ef-8c0e-de89e7cdb749.webp",
    "width": 523,
    "height": 250
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ef-c36a-72bf-abcc-73eccc239b8e.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ef-c36a-72bf-abcc-73eccc239b8e",
    "storage_key": "property/5198384616964096/019d02ef-c36a-72bf-abcc-73eccc239b8e.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ed-d944-73ef-8c0e-de89e7cdb749.webp",
  "property_icon_media": {
    "alt_text": "Watersedge Webster Texas logo",
    "public_id": "019d02ed-d944-73ef-8c0e-de89e7cdb749",
    "storage_key": "property/5198384616964096/019d02ed-d944-73ef-8c0e-de89e7cdb749.webp",
    "width": 523,
    "height": 250
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a1e-ae1f-7649-a796-94609c2665e2.webp",
  "property_fav_icon_media": {
    "alt_text": "Waters Edge Webster TX logo",
    "public_id": "019e8a1e-ae1f-7649-a796-94609c2665e2",
    "storage_key": "property/5198384616964096/019e8a1e-ae1f-7649-a796-94609c2665e2.webp",
    "width": 1156,
    "height": 1156
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ed-d8e7-7479-aed2-fc46089cc214.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d02ed-d8e7-7479-aed2-fc46089cc214",
    "storage_key": "property/5198384616964096/019d02ed-d8e7-7479-aed2-fc46089cc214.webp",
    "width": 523,
    "height": 250
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f8b61-ad9c-7021-817b-1bcdc68a3256.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f8b61-ad9c-7021-817b-1bcdc68a3256",
    "storage_key": "property/5198384616964096/019f8b61-ad9c-7021-817b-1bcdc68a3256.webp",
    "width": 523,
    "height": 250
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#5e7975",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#002d39",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "650 - 1219",
  "property_sqft_min": "650",
  "property_sqft_max": "1219",
  "property_price_range": "1309.66 - 1980",
  "property_price_min": "1309.66",
  "property_price_max": "1980",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/watersedgeaptliving",
  "property_instagram_url": "https://www.instagram.com/watersedgeaptliving",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJF7hPw6CcQIYR92By5latm4I",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?cflt=apartments&find_near=rosemont-clear-creek-webster",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Comfort shows up in the everyday details.</strong> At Watersedge, charge your car, grab packages from Parcel Pending lockers, work out in the 24-hour fitness studio, or relax by resort-inspired pools with grilling areas close by. Select apartments add quartz bathroom countertops, stainless-steel appliances, full-size washers and dryers, oversized closets, sunrooms, vaulted ceilings, and patios or balconies with lake or pool views.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at Watersedge.</strong> Choose from one- and two-bedroom apartments in Webster with open flow, defined living space, and options like sunrooms, private outdoor space, or two-bath layouts. Select homes add polished everyday perks, including custom cabinetry, stainless-steel appliances, quartz bathroom countertops, vaulted ceilings, oversized closets, full-size washers and dryers, and lake or pool views.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Watersedge.</strong> Preview bright interiors with sleek kitchen appliances, oversized windows, and sunrooms or balconies that draw the views in. Then follow the photos outside to poolside loungers, grilling and picnic areas, lakeside paths, and calm water views with lighted fountains—all captured to give the gallery its sense of place.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Webster energy, Clear Lake ease.</strong> Watersedge puts FM 528 at your doorstep with quick connections to NASA Parkway, I-45, Baybrook Mall, Topgolf Webster, and Marina Gate dining favorites like JINYA Ramen Bar and Paris Baguette. For a quieter reset, nearby trails, lake scenery, and Challenger Seven Memorial Park bring the Bay Area’s natural side into view.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents keep coming back to the same highlights:</strong> responsive service, clean surroundings, well-lit grounds, and maintenance requests handled quickly. Reviews also give shoutouts to team members like Abby, Caitlin, Aubrey, Arbresha, and Edwin for making leasing, move-in, and everyday questions easier. See why Watersedge is described as “nice, quiet, and peaceful” in Webster.</p>",
  "property_neighborhood_blurb": "<p><strong>Plug into Webster’s Clear Lake rhythm.</strong> From Watersedge, FM 528 keeps NASA Parkway, I-45, and Bay Area Park &amp; Ride within easy reach while dining, retail, and entertainment stay close to home. Head toward Baybrook Mall’s outdoor Lawn, meet up at Topgolf Webster, or explore Marina Gate favorites like JINYA Ramen Bar, Gen Korean BBQ House, Paris Baguette, and Scout Bar.</p><p>When you want fresh air, follow the neighborhood’s lake-and-trail mood back home or branch out to Challenger Seven Memorial Park, where wetlands and Clear Creek scenery bring a quieter side of the Bay Area into focus. Ready to map your routine? Browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Webster living connects at Watersedge.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everyday ease, built into the details.</strong> At Watersedge, amenities go beyond a quick checklist—so your routine feels smoother from morning coffee to evening downtime. Charge up at the car charging station, pick up deliveries from Parcel Pending package lockers, fit in a workout at the 24-hour fitness studio, or unwind by one of the resort-inspired pools with grilling areas nearby.</p><p>Inside, select apartments add the kind of finishes that make daily living feel polished: custom cabinetry, quartz bathroom countertops, stainless-steel appliances, full-size washers and dryers, oversized closets, sunrooms, vaulted ceilings, and private patios or balconies with lake or pool views. Controlled access, key fob entry, online resident services, and walking/biking trails round out a Webster apartment community designed for comfort, convenience, and a little more breathing room.</p>",
  "property_applynow_blurb": "<p><strong>Ready for lake-view living in Webster?</strong> Watersedge brings calm, connected apartment living with one- and two-bedroom layouts, walking trails, lighted fountains, and inviting finishes like sunrooms, private patios or balconies, oversized closets, and in-home washers and dryers. Start your online application today and take the next step toward Watersedge.</p>",
  "property_contactus_blurb": "<p><strong>Questions about Watersedge?</strong> Reach out to our leasing team for details, directions, or help planning your visit. We’re happy to point you toward available one- and two-bedroom layouts, lake-view living, and the calm, connected setting that makes Watersedge feel like home.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Watersedge?</strong> Start here for quick answers about the community, leasing, amenities, and everyday life at our lake-view apartments in Webster. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space that fits your day.</strong> Watersedge offers one-bedroom and two-bedroom apartment layouts in Webster, with options that balance easy flow, defined living areas, and extra breathing room where it counts. Choose a streamlined one-bedroom with a sunroom or private outdoor space, or spread out in a two-bedroom, two-bath plan with room to work, unwind, and store more.</p><p>Inside select homes, details like custom cabinetry, quartz bathroom countertops, stainless-steel appliances, vaulted ceilings, garden-style tubs, full-size washers and dryers, oversized closets, and lake or pool views make each plan feel polished and practical. Browse current pricing and availability, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See Watersedge in the details.</strong> Browse a gallery that moves from sunlit apartment interiors to relaxed outdoor spaces, giving you a clearer feel for life in this Webster community. Picture kitchens with sleek appliances and bright counters, living areas framed by oversized windows, and sunrooms or balconies that bring the view a little closer.</p><p>Outside, the photos capture the moments that make the setting stand out: poolside loungers, grilling and picnic spots, lakeside paths, and calm water views with lighted fountains. Take your time with the images, explore more <a href=\"/amenities\">community amenities</a>, or continue into the <a href=\"/virtual-tours\">virtual tours</a> for a closer look.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore lake-view living in Webster.</strong> Use the interactive map to find available one- and two-bedroom apartments at Watersedge, then see how FM 528/West NASA Parkway connects you to nearby shopping, dining, Clear Lake, parks, trails, and everyday conveniences.</p>",
  "property_pets_blurb": "<p><strong>Room to roam, sniff, nap, and settle in.</strong> Watersedge makes pet-friendly apartment living in Webster feel easy, with cats and dogs welcome, up to two per home, and no weight limit. Start the day on the community’s lush walking trails with lake views, then give your pup a change of pace at the spacious bark park.</p><p>Inside, choose a layout that supports your routine—whether that means a private patio or balcony for fresh-air lounging, a sunroom for sunny cat naps, or oversized closets that help keep leashes, toys, and supplies tucked away. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Watersedge fits life with your pet.</p>",
  "property_referafriend_blurb": "<p><strong>Share lake-view living at Watersedge.</strong> If walking trails, lighted fountains, resort-inspired pools, and calm, connected apartment living are what you love most, invite a friend to experience it here. Send a referral today and help them find their next one- or two-bedroom home in Webster.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong><br>Log in to pay rent, submit maintenance requests, and manage your Watersedge account from one convenient place—so you can get back to calm, connected lake-view living in the heart of Webster.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying about Watersedge.</strong> As you browse the reviews, you’ll notice the same themes come up again and again: attentive service, clean surroundings, timely maintenance, and a team that makes the move-in and day-to-day experience feel easier.</p><p>Residents call out team members like Abby, Caitlin, Aubrey, Arbresha, and Edwin for being helpful, knowledgeable, and responsive. One reviewer described the community as “nice, quiet, and peaceful,” while another praised the well-lit property and quick service requests. You’ll also see appreciation for the Webster location, the apartment homes, and the care shown by the leasing and maintenance teams.</p>",
  "property_created_at": "1752256326219",
  "property_scheduletour_blurb": "<p><strong>See lake-view living up close.</strong> Tour Watersedge and picture the calm of walking trails, lighted fountains, and one- or two-bedroom layouts with details like sunrooms, private patios or balconies, oversized closets, and full-size washers and dryers. Schedule your visit today and experience the setting in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Watersedge’s leasing team will be in touch soon. In the meantime, picture lake-view living in Webster with walking trails, lighted fountains, inviting one- and two-bedroom layouts, and resort-inspired spaces that make home feel calm, connected, and easy to enjoy.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Watersedge before you arrive.</strong> Use these virtual tours to move from community spaces into the apartment layouts that matter most, all at your own pace. Explore two community tours for a feel of the setting, then step inside one-bedroom and two-bedroom options—including one-bath and two-bath homes—to compare flow, natural light, storage, and everyday finishes up close.</p><p>As you click through, notice the details that are easier to judge in motion: open living areas, polished kitchens, oversized closets, and select connections to a sunroom, patio, or balcony. When a tour catches your eye, compare it with current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Watersedge in Webster in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Watersedge",
  "property_seo_title_home": "Watersedge |  Apartments in Webster, TX",
  "property_seo_description_home": "Experience modern living at Watersedge in Webster, TX. Enjoy spacious floor plans, luxurious amenities, and a vibrant community. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Webster, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Watersedge in Webster, TX! Choose from stylish one and two-bedroom floor plans that perfectly suit your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Webster, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort and convenience at Watersedge in Webster, TX. Enjoy a pool, fitness center, dog park, and more in your stylish new home. Elevate your lifestyle!",
  "property_seo_title_gallery": "Gallery | Apartments in Webster, TX",
  "property_seo_description_gallery": "Picture life at Watersedge in Webster, TX! Stunning apartments with pools, fitness center, dog park, and more await. Imagine your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Watersedge Apartments",
  "property_seo_description_virtualtours": "Immerse yourself in Watersedge, Webster, TX! Take a virtual tour of our chic one and two-bedroom apartments, where comfort meets modern living.",
  "property_seo_title_interactivemap": "Interactive Map | Watersedge Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Watersedge in Webster, TX! Use our interactive community map to explore floor plans and amenities like a pool, fitness center, and more!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Webster, TX",
  "property_seo_description_neighborhood": "Unwind at Watersedge in Webster, TX! Dive into vibrant local favorites, parks, and more. Discover your perfect neighborhood to call home.",
  "property_seo_title_contact": "Contact Us | Watersedge",
  "property_seo_description_contact": "Connect with Watersedge in Webster, TX! Choose from spacious one and two-bedroom floor plans. Have questions? Our leasing team is ready to help you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Webster, TX",
  "property_seo_description_faqs": "Uncover essential info about Watersedge in Webster, TX. From floor plans to amenities, find answers to your questions and see why our community feels like home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Webster, TX",
  "property_seo_description_reviews": "Join the Watersedge family in Webster, TX! Dive into comfort with top-notch amenities, scenic trails, and resident love. See what makes us special!",
  "property_seo_title_applynow": "Apply Now | Apartments in Webster, TX",
  "property_seo_description_applynow": "Find your perfect fit at Watersedge in Webster, TX! Choose from spacious one or two-bedroom apartments with top-notch amenities. Ready to make the move?",
  "property_seo_title_residentaccess": "Resident Access | Watersedge",
  "property_seo_description_residentaccess": "Log into Watersedge's resident portal to manage your home in Webster, TX. Pay rent, request maintenance, and enjoy seamless living at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Watersedge",
  "property_seo_description_referafriend": "Refer a friend to Watersedge in Webster, TX! Great friends make great neighbors—join our vibrant community and enjoy lakeside living together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Watersedge",
  "property_seo_description_scheduletour": "Experience Watersedge in Webster, TX. Schedule your tour today and envision a vibrant lifestyle surrounded by serene waters and modern comforts.",
  "property_seo_title_privacy": "Privacy Policy | Watersedge",
  "property_seo_description_privacy": "At Watersedge in Webster, TX, your privacy matters! Learn how we protect your personal information with our transparent privacy policy. Your trust is our priority.",
  "property_seo_title_accessibility": "Website Accessibility | Watersedge",
  "property_seo_description_accessibility": "At Watersedge in Webster, TX, we prioritize digital inclusion for all. Experience seamless access in our community where everyone feels at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Watersedge",
  "property_seo_description_sitemap": "Navigate your way with ease! Check out Watersedge's sitemap to find everything you need for vibrant living in Webster, TX. Your future home awaits!",
  "property_seo_title_thankyou": "Thank You | Watersedge",
  "property_seo_description_thankyou": "Thank you for reaching out! A Watersedge team member will be in touch soon to help you find your perfect home in Webster, TX. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Riverview, FL",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651140040",
  "amenities": [
    {
      "id": "custom_15ca0b73-6b7f-47cf-9afd-309c259df2af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c8a92bf0-7731-4d8d-9829-af6fd0b9e741",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_092f0225-c962-4d50-9f52-0aa26362a36a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz Countertops in Bathrooms",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_792f0bd3-72f2-47a6-8c94-9ff2926e1e9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Custom Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a06f453b-947f-451e-9770-d1166321eb36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Oversized Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c66fa7b-f940-42da-ac18-75fd50f24449",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Style Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8754c3e-7fa4-464d-ad20-9ee6253061ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios or Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5c40d391-cee2-4411-8812-dc5dfc797a5b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000689",
      "title": "Sunroom",
      "amount": "0.0000",
      "description": "Sunrooms",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_78d82644-2e22-4955-9c5d-9d5bdbef7c8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000687",
      "title": "Storage Spaces",
      "amount": "0.0000",
      "description": "Patio Storage",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8fba54f0-43b6-4a71-bf9d-a88358d06ec3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Vaulted Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_217de025-15fc-412b-9637-6ebdc2ff7eca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool w/Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dab3032d-d769-4cdc-9c25-f93b27cc5f6e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d16ed1f-ace6-4dea-a489-198df29ebb7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "State-Of-The-Art Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8b620f82-3e94-45e4-8ba0-2aceb529b0ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Picnic Areas w/ Grilling Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_12923564-e5f6-4d88-9a28-6a28a94596e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "On-Site Laundry Facility",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3605481-4e78-4993-9d55-8a5596de7eab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000002380",
      "title": "Billiards Room",
      "amount": "0.0000",
      "description": "Billiards Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_de6b6d45-12d8-41a5-a374-61e335f4dc1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b0b34cc-7f20-4b45-9994-5e95c880d06f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_972837c9-7b0d-449a-96b8-e2dc1c89cf1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "title": "Community",
      "description": "Welcome to Emerson Park, featuring a beautiful exterior with lush landscaping, manicured bushes, and vibrant flowers, creating an inviting atmosphere.",
      "link": "",
      "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da23038a-9e58-4320-9f2b-3c59b116e3fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-b2ee-760e-a0da-5e0d906762d3.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sofa, wooden armchair, coffee table, and abstract art.",
        "public_id": "019e8a0c-b2ee-760e-a0da-5e0d906762d3",
        "storage_key": "property/5198384616964096/019e8a0c-b2ee-760e-a0da-5e0d906762d3.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sofa, a chic wooden armchair, a modern coffee table, and eye-catching abstract wall art. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a gray sofa, wooden armchair, coffee table, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de79cbb4-3796-406a-b411-6609ee5b61b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-b29e-7269-be01-38c81f5c0ec7.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, free weights, medicine balls, and yoga balls.",
        "public_id": "019e8a0c-b29e-7269-be01-38c81f5c0ec7",
        "storage_key": "property/5198384616964096/019e8a0c-b29e-7269-be01-38c81f5c0ec7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with a variety of weight machines, free weights, and exercise balls for a comprehensive workout.",
      "link": "",
      "alt_text": "Fitness center with weight machines, free weights, medicine balls, and yoga balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e7f4fa3d-735d-4c98-a59c-0583d6fa891f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-b0d9-773a-8c18-5bf7dc8d3008.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8a0c-b0d9-773a-8c18-5bf7dc8d3008",
        "storage_key": "property/5198384616964096/019e8a0c-b0d9-773a-8c18-5bf7dc8d3008.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool, complete with comfortable lounge chairs and shaded areas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45181651-ab61-4788-89ca-7c9d1c1a2d49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-b1f0-71c9-b375-bfca3350bbd6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and a large sink. A glimpse of a bedroom is visible through an open doorway.",
        "public_id": "019e8a0c-b1f0-71c9-b375-bfca3350bbd6",
        "storage_key": "property/5198384616964096/019e8a0c-b1f0-71c9-b375-bfca3350bbd6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Discover the perfect blend of style and functionality in our modern kitchens, featuring stainless steel appliances, quartz countertops, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and a large sink. A glimpse of a bedroom is visible through an open doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51974860-4a53-4c3b-967d-44c5f2ea856b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-ae56-7502-b068-59d3c7475e77.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and decorative wall hangings.",
        "public_id": "019e8a0c-ae56-7502-b068-59d3c7475e77",
        "storage_key": "property/5198384616964096/019e8a0c-ae56-7502-b068-59d3c7475e77.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Renovated bathroom featuring a sleek vanity with a quartz countertop, a large mirror, and stylish decorative elements. Includes a modern toilet and elegant wood-look flooring.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and decorative wall hangings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_875bb430-4c20-47cc-9ac5-06d5f57cc0a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-9e40-75d7-be0c-99b854efa006.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with built-in grills under a wooden pergola near a swimming pool.",
        "public_id": "019e8a0c-9e40-75d7-be0c-99b854efa006",
        "storage_key": "property/5198384616964096/019e8a0c-9e40-75d7-be0c-99b854efa006.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our modern built-in grills, perfect for al fresco dining by the pool.",
      "link": "",
      "alt_text": "Outdoor kitchen with built-in grills under a wooden pergola near a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_00fa59fa-7fd4-4b7c-a724-7fcd8e04c62e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-9b5c-7357-82db-25b0e09ea833.webp",
      "image_media": {
        "alt_text": "Stylish living room with a gray sectional sofa, coffee table, and large window with vertical blinds.",
        "public_id": "019e8a0c-9b5c-7357-82db-25b0e09ea833",
        "storage_key": "property/5198384616964096/019e8a0c-9b5c-7357-82db-25b0e09ea833.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living space, featuring comfortable seating and ample natural light.",
      "link": "",
      "alt_text": "Stylish living room with a gray sectional sofa, coffee table, and large window with vertical blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c69752e-2d06-4ef5-a313-32dccf8a6db2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-9a00-745e-919c-0946d4b4894f.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019e8a0c-9a00-745e-919c-0946d4b4894f",
        "storage_key": "property/5198384616964096/019e8a0c-9a00-745e-919c-0946d4b4894f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9a43f91e-58da-4065-ac18-810606204b79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-9d8f-756c-a179-a0265b89c689.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table, large dining table, bar seating, and a kitchenette.",
        "public_id": "019e8a0c-9d8f-756c-a179-a0265b89c689",
        "storage_key": "property/5198384616964096/019e8a0c-9d8f-756c-a179-a0265b89c689.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our community lounge, featuring a full kitchenette, comfortable seating, and entertainment options like a pool table.",
      "link": "",
      "alt_text": "Community lounge area with a pool table, large dining table, bar seating, and a kitchenette.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d84dcb7a-f031-4b02-8f20-62f0a26a9db7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-9c82-77aa-b189-c0783f8fcd07.webp",
      "image_media": {
        "alt_text": "Bedroom with a wooden bed, grey blanket, and blue and white patterned comforter.",
        "public_id": "019e8a0c-9c82-77aa-b189-c0783f8fcd07",
        "storage_key": "property/5198384616964096/019e8a0c-9c82-77aa-b189-c0783f8fcd07.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a comfortable bed with plush bedding, complemented by modern wall art and a nightstand.",
      "link": "",
      "alt_text": "Bedroom with a wooden bed, grey blanket, and blue and white patterned comforter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c4b06e0-5613-468f-a2e1-62d7cc5f2a0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-992b-7697-a84b-773d89faf1f8.webp",
      "image_media": {
        "alt_text": "Dining area with a round wooden table, four brown leather chairs, and large windows with white curtains.",
        "public_id": "019e8a0c-992b-7697-a84b-773d89faf1f8",
        "storage_key": "property/5198384616964096/019e8a0c-992b-7697-a84b-773d89faf1f8.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area featuring a round wooden table with seating for four and large windows that let in plenty of natural light.",
      "link": "",
      "alt_text": "Dining area with a round wooden table, four brown leather chairs, and large windows with white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f7f283cd-83fd-4b7a-81f7-cf5fd72ffa4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-99c0-703e-a1a7-cf326c5a6b23.webp",
      "image_media": {
        "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas in front of the apartment building.",
        "public_id": "019e8a0c-99c0-703e-a1a7-cf326c5a6b23",
        "storage_key": "property/5198384616964096/019e8a0c-99c0-703e-a1a7-cf326c5a6b23.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Beautiful outdoor swimming pool with lounge chairs and umbrellas in front of the apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f11f330-f361-486f-9805-54e070bba19a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-97fd-77bb-8d1b-67ff07fc5b8b.webp",
      "image_media": {
        "alt_text": "Communal dining area with leather booth seating and wood chairs.",
        "public_id": "019e8a0c-97fd-77bb-8d1b-67ff07fc5b8b",
        "storage_key": "property/5198384616964096/019e8a0c-97fd-77bb-8d1b-67ff07fc5b8b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a stylish communal dining area, perfect for residents to connect and relax. Features comfortable booth seating and elegant table arrangements.",
      "link": "",
      "alt_text": "Communal dining area with leather booth seating and wood chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e5fc7e7-f7ff-4d06-9ec1-0b9da684b1de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-995d-75b7-a75f-d5f2bc0f0149.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, gray island, stainless steel appliances, and a view of the living room.",
        "public_id": "019e8a0c-995d-75b7-a75f-d5f2bc0f0149",
        "storage_key": "property/5198384616964096/019e8a0c-995d-75b7-a75f-d5f2bc0f0149.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring white cabinetry, a sleek gray island with a sink, and stainless steel appliances, opening to a stylish living area.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, gray island, stainless steel appliances, and a view of the living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2435416a-2fcc-4e0b-bbdc-0016a35032f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-97c1-73ce-bd7d-c09c9bc26b5c.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving and hanging organizers.",
        "public_id": "019e8a0c-97c1-73ce-bd7d-c09c9bc26b5c",
        "storage_key": "property/5198384616964096/019e8a0c-97c1-73ce-bd7d-c09c9bc26b5c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample white wire shelving and hanging organizers, perfect for storing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with white wire shelving and hanging organizers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5421d119-bb15-4299-8554-41f3af93733a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-8135-76e4-b314-b96c5239c935.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, two sofas, leather armchairs, and coffee table.",
        "public_id": "019e8a0c-8135-76e4-b314-b96c5239c935",
        "storage_key": "property/5198384616964096/019e8a0c-8135-76e4-b314-b96c5239c935.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Elegant living room featuring a stone fireplace, comfortable seating areas with sofas and armchairs, and a rustic coffee table. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, two sofas, leather armchairs, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63372920-ce6c-4a13-ab69-48b276efddb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-80fb-73f8-9d24-7dbcf47cded5.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and lounge area with building in the background.",
        "public_id": "019e8a0c-80fb-73f8-9d24-7dbcf47cded5",
        "storage_key": "property/5198384616964096/019e8a0c-80fb-73f8-9d24-7dbcf47cded5.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and lounge area, perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and lounge area with building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b567bf40-0d3e-4a94-8ebb-61df96f590ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-80fb-73f8-9d24-7b91400fe5e3.webp",
      "image_media": {
        "alt_text": "Watersedge Webster Texas package lockers",
        "public_id": "019e8a0c-80fb-73f8-9d24-7b91400fe5e3",
        "storage_key": "property/5198384616964096/019e8a0c-80fb-73f8-9d24-7b91400fe5e3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Modern package lockers at Watersedge Webster Texas for convenient resident deliveries.",
      "link": "",
      "alt_text": "Watersedge Webster Texas package lockers",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_25ba2876-1f8a-4cc2-9395-4ec23e3e9ea1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-8015-7312-a20c-fd068383552b.webp",
      "image_media": {
        "alt_text": "Keurig coffee maker and coffee station with cups and sweeteners.",
        "public_id": "019e8a0c-8015-7312-a20c-fd068383552b",
        "storage_key": "property/5198384616964096/019e8a0c-8015-7312-a20c-fd068383552b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a fresh cup of coffee from our Keurig coffee maker, fully stocked with cups and sweeteners for your convenience.",
      "link": "",
      "alt_text": "Keurig coffee maker and coffee station with cups and sweeteners.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7721621a-e8c9-4b4b-9bf3-5bffaef1a39d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-8016-74fc-b94f-a788baff07e3.webp",
      "image_media": {
        "alt_text": "Community lounge area with leather booths, tables, and chairs.",
        "public_id": "019e8a0c-8016-74fc-b94f-a788baff07e3",
        "storage_key": "property/5198384616964096/019e8a0c-8016-74fc-b94f-a788baff07e3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating, tables, and elegant decor.",
      "link": "",
      "alt_text": "Community lounge area with leather booths, tables, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f59d387e-ae38-4907-b909-99be98d55e99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-8071-77c8-8895-d3a6753c05d2.webp",
      "image_media": {
        "alt_text": "View from a balcony of a pond with a fountain and apartment buildings beyond.",
        "public_id": "019e8a0c-8071-77c8-8895-d3a6753c05d2",
        "storage_key": "property/5198384616964096/019e8a0c-8071-77c8-8895-d3a6753c05d2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy tranquil pond views and lush landscaping from your private balcony, featuring a charming bistro set for two.",
      "link": "",
      "alt_text": "View from a balcony of a pond with a fountain and apartment buildings beyond.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b23d1e3-7ac3-4fb2-947d-3d9be0bc16e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-8097-71eb-98bc-7a9ce172ed1a.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, a bathtub visible through an open door, and modern decor.",
        "public_id": "019e8a0c-8097-71eb-98bc-7a9ce172ed1a",
        "storage_key": "property/5198384616964096/019e8a0c-8097-71eb-98bc-7a9ce172ed1a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush queen bed and a serene bathroom with a soaking tub, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, a bathtub visible through an open door, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b8020ebe-2bcf-4ada-91bd-1a112e819bb2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-8061-704b-8736-fb8b5deff74d.webp",
      "image_media": {
        "alt_text": "Billiard table and lounge area with views of the pool and apartment buildings.",
        "public_id": "019e8a0c-8061-704b-8736-fb8b5deff74d",
        "storage_key": "property/5198384616964096/019e8a0c-8061-704b-8736-fb8b5deff74d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in our resident lounge, offering comfortable seating and scenic views of the community pool and surrounding buildings.",
      "link": "",
      "alt_text": "Billiard table and lounge area with views of the pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f32229c-3158-4ff3-9095-fa8ee49cecb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-7fcf-7492-9bcf-99577a97388f.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator, microwave, and stove in a modern kitchen.",
        "public_id": "019e8a0c-7fcf-7492-9bcf-99577a97388f",
        "storage_key": "property/5198384616964096/019e8a0c-7fcf-7492-9bcf-99577a97388f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, including a refrigerator, microwave, and oven, with ample cabinet space.",
      "link": "",
      "alt_text": "Stainless steel refrigerator, microwave, and stove in a modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b69dd676-5bde-4fbb-8c30-48b87afd72bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019e8a0c-8021-76dc-938e-9de3d6b2a803.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower",
        "public_id": "019e8a0c-8021-76dc-938e-9de3d6b2a803",
        "storage_key": "property/5198384616964096/019e8a0c-8021-76dc-938e-9de3d6b2a803.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed bathroom, featuring a spacious vanity, modern fixtures, and a relaxing bathtub/shower combination.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_10b2b8f5561a34005db2394a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Snooze, an A.M. Eatery",
      "poi_type": "Restaurants",
      "poi_address": "820 W Bay Area Blvd Ste 120, Webster, TX 77598, USA",
      "poi_short_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_long_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-7e4f-762f-a0d2-f6ec1353b526.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-7e4f-762f-a0d2-f6ec1353b526",
        "storage_key": "property/5198384616964096/019f14e9-7e4f-762f-a0d2-f6ec1353b526.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.snoozeeatery.com/restaurant/texas/clear-lake/?utm_source=Google&utm_medium=BusinessListing",
      "poi_directions_map_url": "https://maps.google.com/?cid=561971669780874740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snooze-an-am-eatery",
      "poi_latitude": "29.5439938",
      "poi_longitude": "-95.1364777",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 346-230-4883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdIPLgadQIYR9EUfl0GGzAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_9a3a993f3201526817c4b02b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "557 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-7f29-70ad-ad94-5d9153384032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-7f29-70ad-ad94-5d9153384032",
        "storage_key": "property/5198384616964096/019f14e9-7f29-70ad-ad94-5d9153384032.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.firstwatch.com/locations/clear-lake/?utm_source=gbp-listing&utm_medium=organic&utm_campaign=gbp-listing&utm_content=clear-lake",
      "poi_directions_map_url": "https://maps.google.com/?cid=6687076670452198165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-watch",
      "poi_latitude": "29.5448459",
      "poi_longitude": "-95.1328933",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-338-8025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvyQ3VGKdQIYRFesaWM1EzVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_93348f3c6960a00ffc379c69",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Cafe Dew",
      "poi_type": "Restaurants",
      "poi_address": "105 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-7fe1-745e-bc37-96edd1402a60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-7fe1-745e-bc37-96edd1402a60",
        "storage_key": "property/5198384616964096/019f14e9-7fe1-745e-bc37-96edd1402a60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://thecafedew.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14073788912536537216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-dew",
      "poi_latitude": "29.5480346",
      "poi_longitude": "-95.1289026",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-525-4541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-ec0a-71dc-9fc8-5bdd281d5f7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-ec0a-71dc-9fc8-5bdd281d5f7c",
        "storage_key": "property/5198384616964096/019f14e9-ec0a-71dc-9fc8-5bdd281d5f7c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJlzZzSgKdQIYRgEiSJ3MkUMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_bd84238ba7a456193c2d624d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Blackline Coffee & Donuts",
      "poi_type": "Restaurants",
      "poi_address": "203 E NASA Pkwy, Webster, TX 77598, USA",
      "poi_short_description": "Cozy, hip coffeehouse serving baked goods, including gluten-free donuts, and kolaches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-87b2-711e-a576-91cbb0ab38e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-87b2-711e-a576-91cbb0ab38e7",
        "storage_key": "property/5198384616964096/019f14e9-87b2-711e-a576-91cbb0ab38e7.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://blacklinecoffeedonuts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7832654552183275734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blackline-coffee--donuts",
      "poi_latitude": "29.538643",
      "poi_longitude": "-95.1176253",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-724-1559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbTyNVm2dQIYR1gA759Ats2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "ec_fc6d253cb76a7f19ccf2f39b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Nobi Public House",
      "poi_type": "Restaurants",
      "poi_address": "241 E NASA Pkwy, Webster, TX 77598, USA",
      "poi_short_description": "Vast selection of craft beers & Asian fusion fare, including banh mi, in a lively, stylish setting.",
      "poi_long_description": "Vast selection of craft beers & Asian fusion fare, including banh mi, in a lively, stylish setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8378-71dc-bb25-e725fc732c17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8378-71dc-bb25-e725fc732c17",
        "storage_key": "property/5198384616964096/019f14e9-8378-71dc-bb25-e725fc732c17.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.nobipub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406355831372941014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nobi-public-house",
      "poi_latitude": "29.5391672",
      "poi_longitude": "-95.1169398",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-932-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY82JUeycQIYR1oaEABdgqXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "ec_c43228688688fa6c6bfab8a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "The Monk's Indian Fusion - Webster",
      "poi_type": "Restaurants",
      "poi_address": "1416 FM 528 Rd Ste d, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8304-77f1-b42f-32bb9c187e02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8304-77f1-b42f-32bb9c187e02",
        "storage_key": "property/5198384616964096/019f14e9-8304-77f1-b42f-32bb9c187e02.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.monkswebster.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11362891109237038244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-monks-indian-fusion---webster",
      "poi_latitude": "29.5261625",
      "poi_longitude": "-95.1353539",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-261-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbeyMwCdQIYRpJyEu0IZsZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_36400d81c7d47626558e0176",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Okii Poke - Webster",
      "poi_type": "Restaurants",
      "poi_address": "1416 FM 528 Rd STE#C, Webster, TX 77598, USA",
      "poi_short_description": "Poke, sushi, and other Hawaiian fare served in a casual setting with a kids' menu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-7f13-75da-b784-ceca8347b59e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-7f13-75da-b784-ceca8347b59e",
        "storage_key": "property/5198384616964096/019f14e9-7f13-75da-b784-ceca8347b59e.webp",
        "width": 1280,
        "height": 895
      },
      "poi_business_url": "http://okiipoke.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713031847507353068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "okii-poke---webster",
      "poi_latitude": "29.5260013",
      "poi_longitude": "-95.13550800000002",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-632-1692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3sLYh6dQIYR7F1XO03o6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c2fa53398c9ccf5c025258d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Pop Top Burgers",
      "poi_type": "Restaurants",
      "poi_address": "3122 FM 528 Rd Ste D, Webster, TX 77598, USA",
      "poi_short_description": "Casual restaurant serving a variety of burgers and small plates in a family-friendly setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8051-7079-b644-85c4752e74cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8051-7079-b644-85c4752e74cf",
        "storage_key": "property/5198384616964096/019f14e9-8051-7079-b644-85c4752e74cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://poptopburgerstx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17493630418599768521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pop-top-burgers",
      "poi_latitude": "29.5233599",
      "poi_longitude": "-95.1614593",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 832-632-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VqYqKGcQIYRyXGbNC7cxfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_f7cc9d3d76e2e78fe1edd4ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "CAVA",
      "poi_type": "Restaurants",
      "poi_address": "1501 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_long_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-87da-757e-8375-d263de05ab3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-87da-757e-8375-d263de05ab3c",
        "storage_key": "property/5198384616964096/019f14e9-87da-757e-8375-d263de05ab3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cava.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8560556057647914221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cava",
      "poi_latitude": "29.538132",
      "poi_longitude": "-95.1472219",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 346-788-3352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdVcE4gybQIYR7Rzs72A0zXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_8cb9d3b0bf06302fdd28d1b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Pappas Seafood House",
      "poi_type": "Restaurants",
      "poi_address": "19991 I-45, Webster, TX 77598, USA",
      "poi_short_description": "Seafood classics fried & grilled, plus other regional favorites like gumbo in a laid-back setting.",
      "poi_long_description": "Seafood classics fried & grilled, plus other regional favorites like gumbo in a laid-back setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8306-70b2-9662-37b642b8af92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8306-70b2-9662-37b642b8af92",
        "storage_key": "property/5198384616964096/019f14e9-8306-70b2-9662-37b642b8af92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://pappasseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12599411386338288524&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pappas-seafood-house",
      "poi_latitude": "29.5365612",
      "poi_longitude": "-95.1368952",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-332-7546",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YeAdpucQIYRjKO0veYZ2q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_ac3d003be5a74301b4d780aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Tommy's Seafood Restaurant & Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "2555 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "Long-standing (since 1994) upscale-yet-casual destination for Gulf oysters, other seafood & steaks.",
      "poi_long_description": "Long-standing (since 1994) upscale-yet-casual destination for Gulf oysters, other seafood & steaks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-850a-7511-9358-29f8c8b6f610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-850a-7511-9358-29f8c8b6f610",
        "storage_key": "property/5198384616964096/019f14e9-850a-7511-9358-29f8c8b6f610.webp",
        "width": 640,
        "height": 426
      },
      "poi_business_url": "https://tommys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16725190768312574583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tommys-seafood-restaurant--oyster-bar",
      "poi_latitude": "29.5769329",
      "poi_longitude": "-95.1076965",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-480-2221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeUWETacQIYRd-Lp0WPQG-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_01c25ec6926534464633c6fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1450 W Bay Area Blvd, Friendswood, TX 77546, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8892-75c9-89b6-8c7a718246f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8892-75c9-89b6-8c7a718246f4",
        "storage_key": "property/5198384616964096/019f14e9-8892-75c9-89b6-8c7a718246f4.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/tx/friendswood-162.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=4974652028511353285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "29.5390788",
      "poi_longitude": "-95.1465869",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-488-0822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-bZKmObQIYRxXmYwKmDCUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_90bf375ac4e44916dda13e03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Whiskey Cake Kitchen & Bar",
      "poi_type": "Restaurants",
      "poi_address": "18840 Gulf Fwy, Friendswood, TX 77546, USA",
      "poi_short_description": "A live-wood grill, smoker & spit are used to prepare food at this hip joint with a whiskey focus.",
      "poi_long_description": "A live-wood grill, smoker & spit are used to prepare food at this hip joint with a whiskey focus.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8e16-714d-94b4-fb4732d92e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8e16-714d-94b4-fb4732d92e34",
        "storage_key": "property/5198384616964096/019f14e9-8e16-714d-94b4-fb4732d92e34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.whiskeycake.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5482728432664046665&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whiskey-cake-kitchen--bar",
      "poi_latitude": "29.5469793",
      "poi_longitude": "-95.1496465",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-558-2253",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcp4GHmbQIYRSezf9HWQFkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_0736a2530c1a41b5fc3da314",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "NASA OIL",
      "poi_type": "Shopping & Retail",
      "poi_address": "1710 FM 528 Rd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8a7f-7761-8f24-632069dd78c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8a7f-7761-8f24-632069dd78c5",
        "storage_key": "property/5198384616964096/019f14e9-8a7f-7761-8f24-632069dd78c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15814843691585468666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nasa-oil",
      "poi_latitude": "29.5250926",
      "poi_longitude": "-95.1406508",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-316-2915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87df-717f-878a-2dc9a9889023",
        "storage_key": "property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVKDVKCcQIYR-nhH_4uceds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_b14590c5e5a4cae8ee3a9683",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1801 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8ebf-739f-898d-7e725cfcb245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8ebf-739f-898d-7e725cfcb245",
        "storage_key": "property/5198384616964096/019f14e9-8ebf-739f-898d-7e725cfcb245.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/webster-tx-pharmacies/1801-w-bay-area-blvd-webster-tx-77598/storeid=16958?WT.mc_id=LS_GOOGLE_RX_16958",
      "poi_directions_map_url": "https://maps.google.com/?cid=10868780887166009343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.5360544",
      "poi_longitude": "-95.151189",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-819-4117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-ebd8-7180-8400-c12c0add5cb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-ebd8-7180-8400-c12c0add5cb9",
        "storage_key": "property/5198384616964096/019f14e9-ebd8-7180-8400-c12c0add5cb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxaknB2WbQIYR_78VsaGq1ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_baac4b6078ae4117b35dc310",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "3100 FM 528 Rd No.B #B, Webster, TX 77598, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8eb9-7494-8b44-2a46cf6407e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8eb9-7494-8b44-2a46cf6407e5",
        "storage_key": "property/5198384616964096/019f14e9-8eb9-7494-8b44-2a46cf6407e5.webp",
        "width": 1280,
        "height": 976
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/webster/3100-fm-528-b/fa83",
      "poi_directions_map_url": "https://maps.google.com/?cid=6894952365828355381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "29.52337",
      "poi_longitude": "-95.1605",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87df-717f-878a-2dc9a9889023",
        "storage_key": "property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKwq2dEGbQIYRNTVwTKXKr18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_92fd726f175877d3d767954f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "3135 FM 528 Rd, Friendswood, TX 77546, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8df3-72ec-8059-91916aabadf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8df3-72ec-8059-91916aabadf6",
        "storage_key": "property/5198384616964096/019f14e9-8df3-72ec-8059-91916aabadf6.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/friendswood/autumn-creek/034/00744?cid=loc_03400744_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17762340309183339269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.5209292",
      "poi_longitude": "-95.1600074",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-557-4563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87df-717f-878a-2dc9a9889023",
        "storage_key": "property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo478tEabQIYRBZt5_GaCgPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_63f2ef371ff2e4c8ea687248",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "18611 Eastfield Dr, Webster, TX 77598, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-4a18-754d-a18d-bbe762f54523.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-4a18-754d-a18d-bbe762f54523",
        "storage_key": "property/5198384616964096/019d02ee-4a18-754d-a18d-bbe762f54523.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/webster/el-dorado-h-e-b-769?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=5688881366909029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.551901",
      "poi_longitude": "-95.1487218",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-488-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87df-717f-878a-2dc9a9889023",
        "storage_key": "property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTa3bqtCbQIYRZUAL6QE2FAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_1ab8605685fa80358ced7e7f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "155 W El Dorado Blvd, Friendswood, TX 77546, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-8eb2-72be-aabc-769c3133a552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-8eb2-72be-aabc-769c3133a552",
        "storage_key": "property/5198384616964096/019f14e9-8eb2-72be-aabc-769c3133a552.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/4702-friendswood-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12422242142545437562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "29.550485",
      "poi_longitude": "-95.1565654",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-286-4471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87dc-70de-bd42-9962e692b2b5",
        "storage_key": "property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9Ra5gJ2bQIYReuNOrGmrZKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_d95813d37afd7052ff967cf2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "1310 Jasmine Ave, Webster, TX 77598, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-91d8-767e-b7b1-5eeae89040fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-91d8-767e-b7b1-5eeae89040fd",
        "storage_key": "property/5198384616964096/019f14e9-91d8-767e-b7b1-5eeae89040fd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/webster-TX-1330.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3639438621570004531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "29.5337935",
      "poi_longitude": "-95.1394705",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-707-7750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87dc-70de-bd42-9962e692b2b5",
        "storage_key": "property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHyMAvUidQIYRM3aEzCTigTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "ec_92b7f4cff74edcd5839c7323",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Baybrook Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "500 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_long_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-493b-70bb-a51b-58752eb4d853.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-493b-70bb-a51b-58752eb4d853",
        "storage_key": "property/5198384616964096/019d02ee-493b-70bb-a51b-58752eb4d853.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.baybrookmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3962758813461213470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baybrook-mall",
      "poi_latitude": "29.5427508",
      "poi_longitude": "-95.148508",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-667-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87dc-70de-bd42-9962e692b2b5",
        "storage_key": "property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOf21c3qbQIYRHnHnLiWM_jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_1afb362f49a55c1b4a4c4e23",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Marshalls & HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1425 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-930b-7510-8691-3336bf3cf482.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-930b-7510-8691-3336bf3cf482",
        "storage_key": "property/5198384616964096/019f14e9-930b-7510-8691-3336bf3cf482.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221170315132036141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls--homegoods",
      "poi_latitude": "29.5378693",
      "poi_longitude": "-95.1443025",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-557-2816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87dc-70de-bd42-9962e692b2b5",
        "storage_key": "property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6brZn2KbQIYRLWRiVFoIe7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_e0a6dbcc2f094746c3196264",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "1355 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-9a27-71b7-8a5d-bd71dd3e9a85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-9a27-71b7-8a5d-bd71dd3e9a85",
        "storage_key": "property/5198384616964096/019f14e9-9a27-71b7-8a5d-bd71dd3e9a85.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://locations.dollartree.com/tx/webster/1355-bay-area-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6340067608325628943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "29.5374695",
      "poi_longitude": "-95.1433128",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-554-1741",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87dc-70de-bd42-9962e692b2b5",
        "storage_key": "property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_ZRW0QGbQIYRD6Q1DuZx_Fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_c35d27766dcf606e86da40fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Little People's Greater Life",
      "poi_type": "Education",
      "poi_address": "1655 FM 528 Rd, Webster, TX 77598, USA",
      "poi_short_description": "Relaxed, warm preschool facility, open to kids from 3 months to 12 years old, offering classes in sign language.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-92ec-70fc-b759-6407989f3c86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-92ec-70fc-b759-6407989f3c86",
        "storage_key": "property/5198384616964096/019f14e9-92ec-70fc-b759-6407989f3c86.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://littlepeoplesgreaterlife.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514353717970862946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-peoples-greater-life",
      "poi_latitude": "29.5238317",
      "poi_longitude": "-95.1405655",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 281-332-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bP5QZacQIYRYgNWh2LH5CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_7262e9e1d08e7e26d3b5ba10",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "The Growing Place",
      "poi_type": "Education",
      "poi_address": "228 N Texas Ave, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-93dc-72d8-8aca-a2082b20747f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-93dc-72d8-8aca-a2082b20747f",
        "storage_key": "property/5198384616964096/019f14e9-93dc-72d8-8aca-a2082b20747f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://growingplacewebster.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3827102929946574464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-growing-place",
      "poi_latitude": "29.5348602",
      "poi_longitude": "-95.1251023",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-545-3641",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkSKXhJOcQIYRgH5SgtaZHDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_4052bdadbedde6772223d378",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Greene Elementary School",
      "poi_type": "Education",
      "poi_address": "2903 Friendswood Link Rd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-95d1-73fd-b0a3-d838737da86d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-95d1-73fd-b0a3-d838737da86d",
        "storage_key": "property/5198384616964096/019f14e9-95d1-73fd-b0a3-d838737da86d.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://greene.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14062661557341546106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greene-elementary-school",
      "poi_latitude": "29.5267972",
      "poi_longitude": "-95.1665799",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-284-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD3nr1T-bQIYRembi4S2cKMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_3c6906556c751c8bbf3cd4b1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Iman Academy Southeast",
      "poi_type": "Education",
      "poi_address": "825 Jetstream Ct, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.imanacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15958684288500033604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iman-academy-southeast",
      "poi_latitude": "29.589886",
      "poi_longitude": "-95.175502",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-204-8710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr4lRS9ebQIYRROimws6ieN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_fd4de070f8c62294939b7c3d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Clear Path Alternative School",
      "poi_type": "Education",
      "poi_address": "1001 Magnolia Ave, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://clearpath.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17230582044511257115&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-path-alternative-school",
      "poi_latitude": "29.5251794",
      "poi_longitude": "-95.121465",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-284-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcWEVicCcQIYRG0JR9BNTH-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_649cab5dd3869c5c9f9379f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Brookside Intermediate",
      "poi_type": "Education",
      "poi_address": "3535 FM 528 Rd, Friendswood, TX 77546, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-9b90-70ca-bc2e-06a7e9e51979.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-9b90-70ca-bc2e-06a7e9e51979",
        "storage_key": "property/5198384616964096/019f14e9-9b90-70ca-bc2e-06a7e9e51979.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://brookside.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12593095300515668640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookside-intermediate",
      "poi_latitude": "29.5208718",
      "poi_longitude": "-95.1658487",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-284-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp9Q9xj6bQIYRoKLgaXSpw64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_6262f689ab7c3fe6047846e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Clear Lake High School",
      "poi_type": "Education",
      "poi_address": "2929 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-989e-700e-aa56-ddd4e16c4170.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-989e-700e-aa56-ddd4e16c4170",
        "storage_key": "property/5198384616964096/019f14e9-989e-700e-aa56-ddd4e16c4170.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://clearlakehs.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5171226152043434160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-lake-high-school",
      "poi_latitude": "29.5823039",
      "poi_longitude": "-95.1057028",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-284-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGxWlczScQIYRsFDCdcniw0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_ad212b976112c5f6ec65a6e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "University of Houston-Clear Lake",
      "poi_type": "Education",
      "poi_address": "2700 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-5039-710c-a5e2-2f747dd1c60c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-5039-710c-a5e2-2f747dd1c60c",
        "storage_key": "property/5198384616964096/019d02ee-5039-710c-a5e2-2f747dd1c60c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uhcl.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17406779386354668934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-houston-clear-lake",
      "poi_latitude": "29.5824608",
      "poi_longitude": "-95.0989342",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-283-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBRIWAM2dQIYRhhVDd6BNkfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_2d5a7fc45f2ce137e81ac31b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Clear Creek High School",
      "poi_type": "Education",
      "poi_address": "2305 E Main St, League City, TX 77573, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-9757-7409-bef5-cef2882d1b65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-9757-7409-bef5-cef2882d1b65",
        "storage_key": "property/5198384616964096/019f14e9-9757-7409-bef5-cef2882d1b65.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://clearcreekhs.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3944614550434849667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-creek-high-school",
      "poi_latitude": "29.5244507",
      "poi_longitude": "-95.0726567",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-284-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH3DoqEOdQIYRg6OBvggWvjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_c684a4e9605430cb71088380",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Clear Brook High School",
      "poi_type": "Education",
      "poi_address": "4607 FM 2351, Friendswood, TX 77546, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-968f-77de-bc67-31c996834238.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-968f-77de-bc67-31c996834238",
        "storage_key": "property/5198384616964096/019f14e9-968f-77de-bc67-31c996834238.webp",
        "width": 1280,
        "height": 633
      },
      "poi_business_url": "https://clearbrook.ccisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15687581460312786455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-brook-high-school",
      "poi_latitude": "29.5480184",
      "poi_longitude": "-95.1867097",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-284-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAcKYm_-aQIYRF4byxjh8tdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_1d6ed2f17de8cb51bdbea4cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Cinemark NASA and XD",
      "poi_type": "Entertainment",
      "poi_address": "20915 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-9957-7667-b136-d51734ae52f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-9957-7667-b136-d51734ae52f6",
        "storage_key": "property/5198384616964096/019f14e9-9957-7667-b136-d51734ae52f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-webster/cinemark-nasa-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7207571296885616326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-nasa-and-xd",
      "poi_latitude": "29.5267127",
      "poi_longitude": "-95.1246749",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-332-0951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-ec19-767c-a428-1c3fecac27ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-ec19-767c-a428-1c3fecac27ef",
        "storage_key": "property/5198384616964096/019f14e9-ec19-767c-a428-1c3fecac27ef.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdqqjr6cQIYRxi4rPOhvBmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_8100af7f90c4166e30d6382b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Star Cinema Grill",
      "poi_type": "Entertainment",
      "poi_address": "702 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Cinema featuring dining options, heated reclining seats and waitstaff service, plus a bar for drinks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-9ad8-7326-a58b-acfee0379631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-9ad8-7326-a58b-acfee0379631",
        "storage_key": "property/5198384616964096/019f14e9-9ad8-7326-a58b-acfee0379631.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/baybrook",
      "poi_directions_map_url": "https://maps.google.com/?cid=12765688306792673863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill",
      "poi_latitude": "29.545818",
      "poi_longitude": "-95.1504157",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-557-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-ec19-767c-a428-1c3fecac27ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-ec19-767c-a428-1c3fecac27ef",
        "storage_key": "property/5198384616964096/019f14e9-ec19-767c-a428-1c3fecac27ef.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fTv5JacQIYRRzK8J-HVKLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_a390fb2648c8999153549444",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Main Event Webster",
      "poi_type": "Entertainment",
      "poi_address": "1125 Magnolia Ave, Webster, TX 77598, USA",
      "poi_short_description": "Texas mini-chain with bowling, billiards, laser tag & arcade, plus eats & full bar.",
      "poi_long_description": "Texas mini-chain with bowling, billiards, laser tag & arcade, plus eats & full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-4336-75df-a570-bc05783561a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-4336-75df-a570-bc05783561a7",
        "storage_key": "property/5198384616964096/019d02ee-4336-75df-a570-bc05783561a7.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/texas/webster",
      "poi_directions_map_url": "https://maps.google.com/?cid=2824197253025658700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-webster",
      "poi_latitude": "29.52384379999999",
      "poi_longitude": "-95.1228347",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-332-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc4J1b6cQIYRTHc6OnCQMSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_9a65a932814bd47fa2bcfa36",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Space Center Houston",
      "poi_type": "Entertainment",
      "poi_address": "1601 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_long_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-4bc5-726a-9d34-3b834983aef1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-4bc5-726a-9d34-3b834983aef1",
        "storage_key": "property/5198384616964096/019f14e7-4bc5-726a-9d34-3b834983aef1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spacecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1436836062198888726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "space-center-houston",
      "poi_latitude": "29.551832",
      "poi_longitude": "-95.0981044",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-244-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8b66-756f-a070-5a8b793421e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8b66-756f-a070-5a8b793421e2",
        "storage_key": "property/5198384616964096/019d02ee-8b66-756f-a070-5a8b793421e2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZlhwACdQIYRFvnVL8mq8BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_85b0975a0c6f43239814a712",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Kemah Boardwalk",
      "poi_type": "Entertainment",
      "poi_address": "215 Kipp Ave, Kemah, TX 77565, USA",
      "poi_short_description": "Family-friendly entertainment including retro rides, a wooden roller coaster & two-story carousel.",
      "poi_long_description": "Family-friendly entertainment including retro rides, a wooden roller coaster & two-story carousel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-9dfc-7537-997f-97eeda5da1a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-9dfc-7537-997f-97eeda5da1a0",
        "storage_key": "property/5198384616964096/019f14e9-9dfc-7537-997f-97eeda5da1a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kemahboardwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3506269467466928315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemah-boardwalk",
      "poi_latitude": "29.5473219",
      "poi_longitude": "-95.0202048",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 281-535-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2iakAJjP4YRuxAq74DFqDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "ec_abf326c5fb586b00fe2a22f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Armand Bayou Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "8500 Bay Area Blvd, Pasadena, TX 77507, USA",
      "poi_short_description": "Vast nature preserve with walking trails & many educational activities, such as guided canoe trips.",
      "poi_long_description": "Vast nature preserve with walking trails & many educational activities, such as guided canoe trips.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-9d99-7686-9d9c-4ec82ebd1cf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-9d99-7686-9d9c-4ec82ebd1cf3",
        "storage_key": "property/5198384616964096/019f14e9-9d99-7686-9d9c-4ec82ebd1cf3.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "http://www.abnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9274310725211214610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armand-bayou-nature-center",
      "poi_latitude": "29.596388",
      "poi_longitude": "-95.078088",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-474-2551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TKtGuKdQIYRElPPmHf4tIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_f6c7bb82f4e9164565dcdeb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Topgolf Webster",
      "poi_type": "Entertainment",
      "poi_address": "21401 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-4272-754d-ad19-d9e5c9618c2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-4272-754d-ad19-d9e5c9618c2a",
        "storage_key": "property/5198384616964096/019f14e7-4272-754d-ad19-d9e5c9618c2a.webp",
        "width": 1280,
        "height": 844
      },
      "poi_business_url": "https://topgolf.com/us/webster/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11038612063024895215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-webster",
      "poi_latitude": "29.5176204",
      "poi_longitude": "-95.1207231",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-657-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-af90c993d2f8",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-af90c993d2f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVcmmxMecQIYR79TwrS8HMZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_41b23eecdf614f854cf18c30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "20251 Gulf Fwy, Webster, TX 77598, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-5798-778c-a2af-882d3cf08827.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-5798-778c-a2af-882d3cf08827",
        "storage_key": "property/5198384616964096/019f14e7-5798-778c-a2af-882d3cf08827.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/texas-bay-area/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=14741702959565579992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "29.53309819999999",
      "poi_longitude": "-95.1316757",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-915-2311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ61cVuC-dQIYR2CY7obwMlcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_dea38655e00e7891f8ff02fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Rowdys Dance Hall",
      "poi_type": "Entertainment",
      "poi_address": "803 E NASA Pkwy suite# 140, Webster, TX 77598, USA",
      "poi_short_description": "Dance hall for line dancing and two-stepping featuring DJs, drinks, and music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-a2df-74ee-adb7-505587cf898f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-a2df-74ee-adb7-505587cf898f",
        "storage_key": "property/5198384616964096/019f14e9-a2df-74ee-adb7-505587cf898f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rowdysdancehall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2174115757545173246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowdys-dance-hall",
      "poi_latitude": "29.5455965",
      "poi_longitude": "-95.1096227",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-984-7802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1wvKhWdQIYR_jAPNcMCLB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dance_hall"
    },
    {
      "id": "ec_6abfe070197d28a33b6eb952",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Baybrook Mall",
      "poi_type": "Entertainment",
      "poi_address": "500 Baybrook Mall, Friendswood, TX 77546, USA",
      "poi_short_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_long_description": "Casual shopping plaza with stores for apparel, footwear, jewelry, home goods & kids, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-493b-70bb-a51b-58752eb4d853.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-493b-70bb-a51b-58752eb4d853",
        "storage_key": "property/5198384616964096/019d02ee-493b-70bb-a51b-58752eb4d853.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.baybrookmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3962758813461213470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baybrook-mall",
      "poi_latitude": "29.5427508",
      "poi_longitude": "-95.148508",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-667-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87dc-70de-bd42-9962e692b2b5",
        "storage_key": "property/5198384616964096/019d02ee-87dc-70de-bd42-9962e692b2b5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOf21c3qbQIYRHnHnLiWM_jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_2a905cf4c5a1fa142c98ffbc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "HCA Houston Healthcare Clear Lake",
      "poi_type": "Health and Wellness",
      "poi_address": "500 W Medical Ctr Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-725b-7194-8df9-a2e7528423c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-725b-7194-8df9-a2e7528423c3",
        "storage_key": "property/5198384616964096/019d02ee-725b-7194-8df9-a2e7528423c3.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/clear-lake?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1498573804104781872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-clear-lake",
      "poi_latitude": "29.5408696",
      "poi_longitude": "-95.1271676",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-332-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8bb6-71c9-adc2-68b3306f11ac",
        "storage_key": "property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAw22Co6cQIYRMBBfX-8AzBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_251e926f9cb4fbbea5057473",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Houston Methodist Clear Lake Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "18300 Houston Methodist Dr, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-a4fb-72cc-b40c-905c4bc8a910.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-a4fb-72cc-b40c-905c4bc8a910",
        "storage_key": "property/5198384616964096/019f14e9-a4fb-72cc-b40c-905c4bc8a910.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/clear-lake/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=14593435753938146129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-clear-lake-hospital",
      "poi_latitude": "29.549487",
      "poi_longitude": "-95.0862312",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-523-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8bb6-71c9-adc2-68b3306f11ac",
        "storage_key": "property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0YjgngmdQIYRUdP3tX9Mhso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_12fe669f9bfd11c52c4d4020",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Memorial Hermann-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "19419 Gulf Fwy ste.3, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-abb1-7239-a18f-3f1addd0ff5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-abb1-7239-a18f-3f1addd0ff5e",
        "storage_key": "property/5198384616964096/019f14e9-abb1-7239-a18f-3f1addd0ff5e.webp",
        "width": 880,
        "height": 742
      },
      "poi_business_url": "https://www.gohealthuc.com/memorialhermann/locations/clear-lake?utm_source=gmb&utm_medium=organic&utm_content=memorialhermann-clear-lake",
      "poi_directions_map_url": "https://maps.google.com/?cid=4086185230324925044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-gohealth-urgent-care",
      "poi_latitude": "29.5426101",
      "poi_longitude": "-95.1392669",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 346-788-3461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJszYsmYOcQIYRdAL3Q9ELtTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_897ac5be3266571954e95bff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "UTMB Health Urgent Care, Webster",
      "poi_type": "Health and Wellness",
      "poi_address": "17448 State Hwy 3 2nd floor, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-affa-7186-9d6e-65c22be79340.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-affa-7186-9d6e-65c22be79340",
        "storage_key": "property/5198384616964096/019f14e9-affa-7186-9d6e-65c22be79340.webp",
        "width": 1280,
        "height": 780
      },
      "poi_business_url": "https://www.utmbhealth.com/urgent-care",
      "poi_directions_map_url": "https://maps.google.com/?cid=1440311626852124633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utmb-health-urgent-care-webster",
      "poi_latitude": "29.5413969",
      "poi_longitude": "-95.1224877",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-505-1748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQKFmbSdQIYR2cdiJMsD_RM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_af1f7968552777232c64d579",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "980 Clear Lake City Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-a63f-762f-ad46-854550f486fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-a63f-762f-ad46-854550f486fd",
        "storage_key": "property/5198384616964096/019f14e9-a63f-762f-ad46-854550f486fd.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/webster-tx-pharmacies/980-clear-lake-city-blvd-at-highway-3-webster-tx-77598/storeid=8442?WT.mc_id=LS_GOOGLE_RX_8442",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787374843318836814&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.5787319",
      "poi_longitude": "-95.1585613",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-480-4410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-ebd8-7180-8400-c12c0add5cb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-ebd8-7180-8400-c12c0add5cb9",
        "storage_key": "property/5198384616964096/019f14e9-ebd8-7180-8400-c12c0add5cb9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7kSAeybQIYRTh5Fh1p1jzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_ff9e9c84977b40eaa3c33c27",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Health and Wellness",
      "poi_address": "18611 Eastfield Dr, Webster, TX 77598, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-4a18-754d-a18d-bbe762f54523.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-4a18-754d-a18d-bbe762f54523",
        "storage_key": "property/5198384616964096/019d02ee-4a18-754d-a18d-bbe762f54523.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/webster/el-dorado-h-e-b-769?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=5688881366909029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.551901",
      "poi_longitude": "-95.1487218",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-488-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87df-717f-878a-2dc9a9889023",
        "storage_key": "property/5198384616964096/019d02ee-87df-717f-878a-2dc9a9889023.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTa3bqtCbQIYRZUAL6QE2FAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_7e40fba0a2f69805ca90edf3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3100 FM 528 Rd Ste A, Webster, TX 77598, USA",
      "poi_short_description": "Clean workout space with cardio machines, free weights and tanning beds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-6610-71f7-9edf-e7063765e1df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-6610-71f7-9edf-e7063765e1df",
        "storage_key": "property/5198384616964096/019f14e7-6610-71f7-9edf-e7063765e1df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/friendswood-bay-area-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2883434336338122770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.52375",
      "poi_longitude": "-95.16034",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-993-4536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQbDC0GbQIYREhiZdkAEBCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_4a76ea0caff044ac4a1f464c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "FS8 Webster",
      "poi_type": "Health and Wellness",
      "poi_address": "935 W Bay Area Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-abb5-77dc-891e-4e739d5e9e21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-abb5-77dc-891e-4e739d5e9e21",
        "storage_key": "property/5198384616964096/019f14e9-abb5-77dc-891e-4e739d5e9e21.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://fs8.com/webster",
      "poi_directions_map_url": "https://maps.google.com/?cid=9534223320737144788&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fs8-webster",
      "poi_latitude": "29.5418179",
      "poi_longitude": "-95.1370785",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-845-3686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ6TKDQCdQIYR1F_IgZhdUIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_42b4a2a135f861a61b547fab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Pilates Powerhouse Webster",
      "poi_type": "Health and Wellness",
      "poi_address": "500 W NASA Pkwy, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-b7db-70e8-802b-bd71c2bb8fc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-b7db-70e8-802b-bd71c2bb8fc3",
        "storage_key": "property/5198384616964096/019f14e9-b7db-70e8-802b-bd71c2bb8fc3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pilates-powerhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7328038544015969528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pilates-powerhouse-webster",
      "poi_latitude": "29.5347477",
      "poi_longitude": "-95.1229714",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-340-1760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJefOX55ydQIYR-Exx7DpssmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_d4e0efe4f999c75cf239c9c1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "BODYBARRE",
      "poi_type": "Health and Wellness",
      "poi_address": "1199 E NASA Pkwy Ste C, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-b834-726e-941d-ff7f8342528c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-b834-726e-941d-ff7f8342528c",
        "storage_key": "property/5198384616964096/019f14e9-b834-726e-941d-ff7f8342528c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bodybarre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1017802588111694578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bodybarre",
      "poi_latitude": "29.5477035",
      "poi_longitude": "-95.1036042",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-284-4569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ37fGlPWcQIYR8uresw_2Hw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_7388b44bb528c452256a61e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Challenger Seven Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2301 W Nasa Blvd, Webster, TX 77598, USA",
      "poi_short_description": "Challenger Space Shuttle disaster memorial & learning center in a 300-acre park with wetlands.",
      "poi_long_description": "Challenger Space Shuttle disaster memorial & learning center in a 300-acre park with wetlands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-7de2-70bb-b659-543574960c54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-7de2-70bb-b659-543574960c54",
        "storage_key": "property/5198384616964096/019f14e7-7de2-70bb-b659-543574960c54.webp",
        "width": 1280,
        "height": 921
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13827686735360768045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "challenger-seven-memorial-park",
      "poi_latitude": "29.5099629",
      "poi_longitude": "-95.1360548",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-332-1903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-95kEAGdQIYRLTiP1tLP5b8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_670035e11dc3f7ecc9f46ff0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Texas Avenue Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17100 N Texas Ave, Webster, TX 77598, USA",
      "poi_short_description": "Urban park with baseball, softball & basketball fields, tennis courts, playgrounds & walking track.",
      "poi_long_description": "Urban park with baseball, softball & basketball fields, tennis courts, playgrounds & walking track.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-bd5c-760f-823d-c46c3295b140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-bd5c-760f-823d-c46c3295b140",
        "storage_key": "property/5198384616964096/019f14e9-bd5c-760f-823d-c46c3295b140.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofwebster.com/886/Texas-Avenue-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6453574986490467572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-avenue-park",
      "poi_latitude": "29.5405465",
      "poi_longitude": "-95.1331001",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-332-1826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKx-fZoWcQIYR9FQc-UG0j1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_dfb1e1f97a704faaa17c4ce9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Clear Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5001 E NASA Pkwy, Seabrook, TX 77586, USA",
      "poi_short_description": "Park with archaeological features on 59 acres with fishing pier, boat launch, playground & trails.",
      "poi_long_description": "Park with archaeological features on 59 acres with fishing pier, boat launch, playground & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-7e2d-70fe-849d-f3b55b89b043.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-7e2d-70fe-849d-f3b55b89b043",
        "storage_key": "property/5198384616964096/019f14e7-7e2d-70fe-849d-f3b55b89b043.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.hcp2.com/facilities/list-parks/104-clear-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11356940434028911940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clear-lake-park",
      "poi_latitude": "29.5655933",
      "poi_longitude": "-95.0678815",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-326-6539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVBSp4-dQIYRRF2QMSf1m50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3f8bd2c4608df53dd17c129e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Armand Bayou Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8500 Bay Area Blvd, Pasadena, TX 77507, USA",
      "poi_short_description": "Vast nature preserve with walking trails & many educational activities, such as guided canoe trips.",
      "poi_long_description": "Vast nature preserve with walking trails & many educational activities, such as guided canoe trips.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-9d99-7686-9d9c-4ec82ebd1cf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-9d99-7686-9d9c-4ec82ebd1cf3",
        "storage_key": "property/5198384616964096/019f14e9-9d99-7686-9d9c-4ec82ebd1cf3.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "http://www.abnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9274310725211214610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armand-bayou-nature-center",
      "poi_latitude": "29.596388",
      "poi_longitude": "-95.078088",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 15 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 281-474-2551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TKtGuKdQIYRElPPmHf4tIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_3abbed3a14e0e80c76fcf9de",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Bay Area Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7500 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "Recreation site on the bayou with a duck pond, baseball field, dog park & playground.",
      "poi_long_description": "Recreation site on the bayou with a duck pond, baseball field, dog park & playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-8c41-74bb-9b2f-7a5715826473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-8c41-74bb-9b2f-7a5715826473",
        "storage_key": "property/5198384616964096/019f14e7-8c41-74bb-9b2f-7a5715826473.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hcp2.com/NEIGHBORHOOD-SERVICES/Parks-and-Trails",
      "poi_directions_map_url": "https://maps.google.com/?cid=9303752298704927509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-park",
      "poi_latitude": "29.5966259",
      "poi_longitude": "-95.0893592",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 713-274-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJezAdT9idQIYRFfuHGmyRHYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_cdb5d8618b7228134fa41fb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Pine Gully Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "605 Pine Gully Rd, Seabrook, TX 77586, USA",
      "poi_short_description": "Large park with a fishing pier on Galveston Bay plus nature trails, playgrounds & picnic facilities.",
      "poi_long_description": "Large park with a fishing pier on Galveston Bay plus nature trails, playgrounds & picnic facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-bdac-74eb-bb52-56ea828ef316.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-bdac-74eb-bb52-56ea828ef316",
        "storage_key": "property/5198384616964096/019f14e9-bdac-74eb-bb52-56ea828ef316.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://seabrooktx.gov/facilities/facility/details/Pine-Gully-Park-12",
      "poi_directions_map_url": "https://maps.google.com/?cid=4407298784787209919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pine-gully-park",
      "poi_latitude": "29.592268",
      "poi_longitude": "-94.9935033",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8I51-djP4YRv55A1uTeKT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8aa8ae74db4d9d2710b05aaf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Friendship Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1500 Red Bluff Rd, Seabrook, TX 77586, USA",
      "poi_short_description": "Tranquil park with swings and slides, as well as walking paths and picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-c5c3-746c-acdf-4b0be88aff6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-c5c3-746c-acdf-4b0be88aff6d",
        "storage_key": "property/5198384616964096/019f14e9-c5c3-746c-acdf-4b0be88aff6d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://seabrooktx.gov/Facilities/Facility/Details/Friendship-Park-7",
      "poi_directions_map_url": "https://maps.google.com/?cid=5854647864124812748&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friendship-park",
      "poi_latitude": "29.5823396",
      "poi_longitude": "-95.0158052",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 281-291-5725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5TKACMtjP4YRzK0okjbjP1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1afdf6d37fc597c129cd40c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Rex L Meador Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2400 Hammer St, Seabrook, TX 77586, USA",
      "poi_short_description": "Neighborhood park with a sand volleyball court, covered basketball courts, and skate park, plus disc golf, and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-cd45-70fe-8e76-365b7261e3f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-cd45-70fe-8e76-365b7261e3f3",
        "storage_key": "property/5198384616964096/019f14e9-cd45-70fe-8e76-365b7261e3f3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.seabrooktx.gov/Facilities/Facility/Details/Rex-Meador-Park-13",
      "poi_directions_map_url": "https://maps.google.com/?cid=9569853549973963367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rex-l-meador-park",
      "poi_latitude": "29.569055",
      "poi_longitude": "-95.0176141",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 281-291-5725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXd757JjP4YRZ4K1thnzzoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1659ebdacff6bdf2bbc7e716",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "McNair Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "411 Tallowood Dr, El Lago, TX 77586, USA",
      "poi_short_description": "Family-friendly park featuring a basketball court, a track, and a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-cb52-728c-b453-f8b8a1e5df50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-cb52-728c-b453-f8b8a1e5df50",
        "storage_key": "property/5198384616964096/019f14e9-cb52-728c-b453-f8b8a1e5df50.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ellago-tx.com/Facilities/Facility/Details/McNair-Memorial-Park-and-Pavilion-5",
      "poi_directions_map_url": "https://maps.google.com/?cid=15797525392632927417&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcnair-memorial-park",
      "poi_latitude": "29.5740336",
      "poi_longitude": "-95.0413506",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-326-1951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkUz5TWpiP4YRuVQZTqUVPNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a7231f57133ebe0378e956e3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Seabrook Wildlife Refuge and Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 Red Bluff Rd, Seabrook, TX 77586, USA",
      "poi_short_description": "Park features deer and other wildlife along its many hiking trails and bike paths.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-d2c7-718f-b8a5-4806e274dc40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d2c7-718f-b8a5-4806e274dc40",
        "storage_key": "property/5198384616964096/019f14e9-d2c7-718f-b8a5-4806e274dc40.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://seabrooktx.gov/Facilities/Facility/Details/14",
      "poi_directions_map_url": "https://maps.google.com/?cid=2851249567115340854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seabrook-wildlife-refuge-and-park",
      "poi_latitude": "29.5867877",
      "poi_longitude": "-95.0101227",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 866-611-4688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f53-729d-a625-a01139382ad9",
        "storage_key": "property/5198384616964096/019d02ee-8f53-729d-a625-a01139382ad9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5CqHM9jP4YRNmzl7V-skSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_aa164e3ea0f5d8013bd5e871",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Bay Area Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-c898-74eb-a57d-3f3e6e704122.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-c898-74eb-a57d-3f3e6e704122",
        "storage_key": "property/5198384616964096/019f14e9-c898-74eb-a57d-3f3e6e704122.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6161951959593641744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bay-area-park--ride",
      "poi_latitude": "29.55289299999999",
      "poi_longitude": "-95.124069",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGxOQR2CcQIYREOeZ6qimg1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_1944064eada832dedb83c1ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "El Dorado Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "203 W El Dorado Blvd, Friendswood, TX 77546, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-d312-76d6-bdad-4ca10878e500.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d312-76d6-bdad-4ca10878e500",
        "storage_key": "property/5198384616964096/019f14e9-d312-76d6-bdad-4ca10878e500.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17653152942922900114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-dorado-park--ride",
      "poi_latitude": "29.5491606",
      "poi_longitude": "-95.1583549",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-ec11-7721-8ab6-ecdfee5a85b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-ec11-7721-8ab6-ecdfee5a85b8",
        "storage_key": "property/5198384616964096/019f14e9-ec11-7721-8ab6-ecdfee5a85b8.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZUQ43WbQIYRkqKPOBKZ_PQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_7a3e69a3edfd59a1fcd10a20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Space Center Houston",
      "poi_type": "Transportation & Transit",
      "poi_address": "1601 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_long_description": "Educational center highlighting all eras of U.S. space travel via exhibits, tours & attractions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-4bc5-726a-9d34-3b834983aef1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e7-4bc5-726a-9d34-3b834983aef1",
        "storage_key": "property/5198384616964096/019f14e7-4bc5-726a-9d34-3b834983aef1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spacecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1436836062198888726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "space-center-houston",
      "poi_latitude": "29.551832",
      "poi_longitude": "-95.0981044",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-244-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8b66-756f-a070-5a8b793421e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8b66-756f-a070-5a8b793421e2",
        "storage_key": "property/5198384616964096/019d02ee-8b66-756f-a070-5a8b793421e2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZlhwACdQIYRFvnVL8mq8BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_0ae3bcc6b78c78f67866abcc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-d630-7436-9ac0-be46a05355c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d630-7436-9ac0-be46a05355c4",
        "storage_key": "property/5198384616964096/019f14e9-d630-7436-9ac0-be46a05355c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "42.3 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "3 hours 42 mins",
      "poi_driving_minutes": "50 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8f52-7136-a975-2c0f4e3f6be0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8f52-7136-a975-2c0f4e3f6be0",
        "storage_key": "property/5198384616964096/019d02ee-8f52-7136-a975-2c0f4e3f6be0.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_21065f81d3bd52ad57f64ba7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Hobby Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "800 Hobby Airport Loop, Houston, TX 77061, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-d94e-74af-8ead-b3bc2c4485da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d94e-74af-8ead-b3bc2c4485da",
        "storage_key": "property/5198384616964096/019f14e9-d94e-74af-8ead-b3bc2c4485da.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13014675115278017802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hobby-transit-center",
      "poi_latitude": "29.65503339999999",
      "poi_longitude": "-95.2756091",
      "poi_miles_from_property": "14.1 mi",
      "poi_walking_minutes": "5 hours 13 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxImLUmWQIYRCiVDCRBqnbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_fd31fb61ffe72ecedf8912cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Joint Reserve Base Ellington",
      "poi_type": "Transportation & Transit",
      "poi_address": "11210 Blume Ave, Houston, TX 77034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-cd98-7588-b2e1-a6991cec2e18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-cd98-7588-b2e1-a6991cec2e18",
        "storage_key": "property/5198384616964096/019f14e9-cd98-7588-b2e1-a6991cec2e18.webp",
        "width": 1080,
        "height": 979
      },
      "poi_business_url": "https://www.goang.com/locations/texas/ellington-field-joint-reserve-base.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1653394884355412175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joint-reserve-base-ellington",
      "poi_latitude": "29.60759419999999",
      "poi_longitude": "-95.1757853",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-929-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-c1c9-7148-b38b-bc87dab08245.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e7-c1c9-7148-b38b-bc87dab08245",
        "storage_key": "property/5198384616964096/019f14e7-c1c9-7148-b38b-bc87dab08245.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXgJrmiZQIYRz9BzI-MJ8hY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_ead1aa6069007ffeeda18477",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "NASA Johnson Space Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Clear Lake, 2101 E NASA Pkwy, Houston, TX 77058, USA",
      "poi_short_description": "NASA's 1,700-acre facility used for mission control & training shuttle & space station astronauts.",
      "poi_long_description": "NASA's 1,700-acre facility used for mission control & training shuttle & space station astronauts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-d88f-7498-b732-c541f0ddddbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-d88f-7498-b732-c541f0ddddbf",
        "storage_key": "property/5198384616964096/019f14e9-d88f-7498-b732-c541f0ddddbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nasa.gov/centers/johnson/home/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2389238764222131620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nasa-johnson-space-center",
      "poi_latitude": "29.552908",
      "poi_longitude": "-95.0933748",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-483-0123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc29kHLCdQIYRpK0NUf9HKCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "ec_b6475c2a40c1d2a40ca586ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "HCA Houston Healthcare Clear Lake",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 W Medical Ctr Blvd, Webster, TX 77598, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-725b-7194-8df9-a2e7528423c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-725b-7194-8df9-a2e7528423c3",
        "storage_key": "property/5198384616964096/019d02ee-725b-7194-8df9-a2e7528423c3.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/clear-lake?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1498573804104781872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-clear-lake",
      "poi_latitude": "29.5408696",
      "poi_longitude": "-95.1271676",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-332-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8bb6-71c9-adc2-68b3306f11ac",
        "storage_key": "property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAw22Co6cQIYRMBBfX-8AzBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_5a4047a32bef79bc0c2efc9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Houston Methodist Clear Lake Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18300 Houston Methodist Dr, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-a4fb-72cc-b40c-905c4bc8a910.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-a4fb-72cc-b40c-905c4bc8a910",
        "storage_key": "property/5198384616964096/019f14e9-a4fb-72cc-b40c-905c4bc8a910.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/clear-lake/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=14593435753938146129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-clear-lake-hospital",
      "poi_latitude": "29.549487",
      "poi_longitude": "-95.0862312",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 281-523-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8bb6-71c9-adc2-68b3306f11ac",
        "storage_key": "property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0YjgngmdQIYRUdP3tX9Mhso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_80a763e1ce528ed10a346b2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "University of Houston-Clear Lake",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2700 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-5039-710c-a5e2-2f747dd1c60c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-5039-710c-a5e2-2f747dd1c60c",
        "storage_key": "property/5198384616964096/019d02ee-5039-710c-a5e2-2f747dd1c60c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uhcl.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17406779386354668934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-houston-clear-lake",
      "poi_latitude": "29.5824608",
      "poi_longitude": "-95.0989342",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-283-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-87e5-730a-8196-a900e2419513",
        "storage_key": "property/5198384616964096/019d02ee-87e5-730a-8196-a900e2419513.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBRIWAM2dQIYRhhVDd6BNkfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_9ccafdbadc2ea0bee4a185d3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "UTMB Health League City Campus Hospital & Clinics",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2240 Gulf Fwy S, League City, TX 77573, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-de16-719f-95a2-4a59ba3fc192.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-de16-719f-95a2-4a59ba3fc192",
        "storage_key": "property/5198384616964096/019f14e9-de16-719f-95a2-4a59ba3fc192.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.utmbhealth.com/lcc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11280674435717029507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utmb-health-league-city-campus-hospital--clinics",
      "poi_latitude": "29.481445",
      "poi_longitude": "-95.098429",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-772-1011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8bb6-71c9-adc2-68b3306f11ac",
        "storage_key": "property/5198384616964096/019d02ee-8bb6-71c9-adc2-68b3306f11ac.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4yESOCCQIYRg16-t6EBjZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_2770cf3ee0928b26b59c0880",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "The Boeing Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3700 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.boeing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9991633183398237187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boeing-company",
      "poi_latitude": "29.5913555",
      "poi_longitude": "-95.1004799",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-226-4141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvXDgR9OdQIYRAxR1PnFpqYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_b27f76217383622f9f44a590",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Lockheed Martin Cargo MSN",
      "poi_type": "Major Employers & Offices",
      "poi_address": "595 Gemini St, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7803274532273658412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lockheed-martin-cargo-msn",
      "poi_latitude": "29.5498291",
      "poi_longitude": "-95.1244403",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoQKg84qcQIYRLBoG9dfMSmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shipping_service"
    },
    {
      "id": "ec_910de5444d6ec44e5dda5c13",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Axiom Space - Headquarters & Spacesuit Facility",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1300 Hercules Ave, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-81d3-7199-8bb5-4dde0a3d777f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ee-81d3-7199-8bb5-4dde0a3d777f",
        "storage_key": "property/5198384616964096/019d02ee-81d3-7199-8bb5-4dde0a3d777f.webp",
        "width": 1280,
        "height": 918
      },
      "poi_business_url": "https://www.axiomspace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10716935983294945610&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "axiom-space---headquarters--spacesuit-facility",
      "poi_latitude": "29.5566231",
      "poi_longitude": "-95.1107909",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 346-293-7045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtW7-4E2dQIYRSpnl_H40upQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_2b886045804c40ca1a96f803",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Amentum",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2224 Bay Area Blvd, Houston, TX 77058, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-e37d-7549-818e-8e2fddc5ac51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-e37d-7549-818e-8e2fddc5ac51",
        "storage_key": "property/5198384616964096/019f14e9-e37d-7549-818e-8e2fddc5ac51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amentum.com/markets/space/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18112318265827753219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amentum",
      "poi_latitude": "29.5712257",
      "poi_longitude": "-95.10914710000002",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-461-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ee-8ba8-7268-97ee-b49c0c1e3bda",
        "storage_key": "property/5198384616964096/019d02ee-8ba8-7268-97ee-b49c0c1e3bda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3UVHHEmcQIYRA3175X_hW_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "ec_57c4203f0d9386d71439c150",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "generator",
      "poi_name": "Joint Reserve Base Ellington",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11210 Blume Ave, Houston, TX 77034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e9-cd98-7588-b2e1-a6991cec2e18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-cd98-7588-b2e1-a6991cec2e18",
        "storage_key": "property/5198384616964096/019f14e9-cd98-7588-b2e1-a6991cec2e18.webp",
        "width": 1080,
        "height": 979
      },
      "poi_business_url": "https://www.goang.com/locations/texas/ellington-field-joint-reserve-base.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1653394884355412175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joint-reserve-base-ellington",
      "poi_latitude": "29.60759419999999",
      "poi_longitude": "-95.1757853",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-929-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14e7-c1c9-7148-b38b-bc87dab08245.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e7-c1c9-7148-b38b-bc87dab08245",
        "storage_key": "property/5198384616964096/019f14e7-c1c9-7148-b38b-bc87dab08245.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXgJrmiZQIYRz9BzI-MJ8hY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "custom_50c04d52-5770-4553-8df0-18193b889128",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_91a88446-60c5-46a7-bae0-801d6d601f5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c02db640-2d01-42e5-addd-e27e75b3bf78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5766dd95-8f94-4d8c-aab8-fd5dd8fffd67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7c797807-875f-45f5-8662-992c882dbe2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3fbc8d7c-c45b-49b3-bf10-2b025f74835f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_f2754bd1fa455393c62fd7a5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "rating": "5",
      "name": "john crowell",
      "text": "Opening Day: Moving into my new apartment at Watersedge.\nThe move is officially in the books, and it was a shutout victory thanks to a powerhouse staff rotation. Here’s the score:\n• The Starter: Caitlin\nCaitlin took the mound early and dominated, a true ace who set the tempo for the win.\n• The Reliever: Aubrey\nComing in hot for the middle, providing the perfect bridge.\n• The Closer: Arbresha\nWhen it was the bottom of the 9th, Arbresha entered the game to shut it down.\nI’ve only been here for a week so far, but I love the apartment, the location is amazing as well….\nGame Over",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "ec_4dc87dcb81f38bcbd6837fb3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "rating": "5",
      "name": "Kris Doucet",
      "text": "I’ve really enjoyed living here. The complex is well run, and the office staff is always helpful. A special thank you to Abby for her ongoing support over the years—she’s always been friendly, knowledgeable, and great to work with. I truly appreciate everything she does.",
      "date": "2026-01-13",
      "title": "false"
    },
    {
      "id": "ec_b436ba5c28f4a76e28bf84f1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "rating": "5",
      "name": "Nashir Momin",
      "text": "This is an exceptional apartment to live at in the Webster and League City .\n\nThe leasing and maintenance staff go above and beyond. After spending more than 2 years here , I can confidently affirm how rare it is to see staff that care about their tenants to the level seen here.\n\nWhat really stands out to me is how the management treats you. Everyone here — from the concierge to the leasing office, and even the maintenance team — is genuinely amazing. A special shout-out to Caitlin and Abby they are super friendly and did an awesome job There  professionalism and warmth really set the tone for the entire community.\n\nThe community is nice, quiet, and peaceful.  The community is beautiful, the amenities are top-notch, and the location in the heart of webster ….unbeatable!",
      "date": "2026-02-27",
      "title": "false"
    },
    {
      "id": "ec_88e0aa4b4d79dce05422a1bc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "rating": "5",
      "name": "Juliebella V",
      "text": "We love living here! The property and facilities are always clean, and we feel very safe, even at night. The community is well lit, and the staff is always attentive and our service requests are always completed in a timely manner. The maintenance supervisor Edwin is awesome, he is very professional, knowledgeble, helpful and always keeps us updated on any repairs or concerns that we might have. We would definitely recommend these apartments to our friends and family. Five stars!",
      "date": "2025-09-09",
      "title": "false"
    },
    {
      "id": "ec_fc6e8e76faef3cb0c9afdacc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "rating": "5",
      "name": "Riyan Momin",
      "text": "I've been living at this apartment complex for almost around 10+ years now. I moved here when it was originally called Emerson Park. Abby was a manager here at that time, and once Watersedge took over she was still the manager at Watersedge. Sometime around summer of 2025, I was needing to move to a bigger unit within the apartment complex, but at that time Abby was no longer the manager and it was Kemi. Kemi gave us the worst experience in 1 month which Abby had never given us in 10 years. While moving, Kemi did not care about anything except herself, she was harassing us during our move to the new unit, making minor things a major headache, which then caused us to cancel our move since she did not help us in any possible way. During the transfer of management in Summer 2025, the apartment complex fell off a bit, service orders wouldn't be completed on time, gate's wouldn't work, etc. But once Abby came back after the summer, she prioritized those issues and resolved them. We also started our move process once again, and this time we had no issues with Abby like we had with Kemi. Abby took great care of the move, looking at our old unit to see the condition of it, and making sure the new unit was up-to-date and that we had a good experience moving. Abby has always been kind-hearted and sweet to my family and I. She is understanding and has always resolved our problems one way or another. I highly recommend talking to Abby if you're facing any issues with the 2 receptionist up-front, I promise Abby will help you like she's your own family.",
      "date": "2026-01-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_d368b4a7-76df-4146-b032-cb5a4aaf8a09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14c2-a12a-7767-8d02-8044eb91c196.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-a12a-7767-8d02-8044eb91c196",
        "storage_key": "property/5198384616964096/019f14c2-a12a-7767-8d02-8044eb91c196.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 972SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=X6B2XEtQKKH"
    },
    {
      "id": "custom_46435a55-0e06-48f6-a72c-2a2a334bde2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14c2-a1a7-776c-bd52-0ea1cbe33249.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-a1a7-776c-bd52-0ea1cbe33249",
        "storage_key": "property/5198384616964096/019f14c2-a1a7-776c-bd52-0ea1cbe33249.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Community Tour | Watersedge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/mNG_Uab4sAs"
    },
    {
      "id": "custom_627b9a01-af23-4405-a312-c1df250b862e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f14c2-a316-71eb-af1e-4f66d8390fd7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-a316-71eb-af1e-4f66d8390fd7",
        "storage_key": "property/5198384616964096/019f14c2-a316-71eb-af1e-4f66d8390fd7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Leasing Office",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?model=GCxEvewBwqe"
    },
    {
      "id": "custom_9d17a2b5-844e-4634-b81f-24e7116e66e8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ef-b5d3-748b-be49-48f0a5509ca3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious bedroom with carpet, ceiling fan, and large window with vertical blinds.",
        "public_id": "019d02ef-b5d3-748b-be49-48f0a5509ca3",
        "storage_key": "property/5198384616964096/019d02ef-b5d3-748b-be49-48f0a5509ca3.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "1BR, 1BA - 640SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QbsyT3bFJEC"
    },
    {
      "id": "custom_f6de747f-f591-4dbc-a586-c7c8591f269a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019de20c-0de7-718e-853d-200b2d8e8ecc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019de20c-0de7-718e-853d-200b2d8e8ecc",
        "storage_key": "property/5198384616964096/019de20c-0de7-718e-853d-200b2d8e8ecc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A1- 650sqft",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oaLtEgwdes8"
    },
    {
      "id": "custom_38935ef5-3a0c-429d-bf45-d3e76e8653fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-cffc-76d9-be77-73b91d19e83d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living area with neutral carpet and large arched entryway.",
        "public_id": "019d02ee-cffc-76d9-be77-73b91d19e83d",
        "storage_key": "property/5198384616964096/019d02ee-cffc-76d9-be77-73b91d19e83d.webp",
        "width": 984,
        "height": 553
      },
      "virtual_tour_title": "1BR, 1BA - 844SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=StUkty7DUb1"
    },
    {
      "id": "custom_024d012e-c5c8-4d5f-8d7c-71abacce5ec4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019d02ee-d784-7753-a69f-5ce0ad3e8bb2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with sliding glass door and ceiling fan.",
        "public_id": "019d02ee-d784-7753-a69f-5ce0ad3e8bb2",
        "storage_key": "property/5198384616964096/019d02ee-d784-7753-a69f-5ce0ad3e8bb2.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2BR, 1BA - 870SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ttHccm2KbXV"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-7100-71e9-a60e-4cebc5c7ed0f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "watersedge",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096"
    },
    {
      "lead_collector_id": "0198aa46-7162-70ff-97a7-042268c693ec",
      "lead_source": "FACEBOOK_ADS",
      "name": "watersedge",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096"
    },
    {
      "lead_collector_id": "0198aa46-71c5-752f-bd35-d49c817ac6e3",
      "lead_source": "LANDING_PAGE",
      "name": "watersedge",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-webster-tx",
      "search_query": "One Bedroom Apartments For Rent In Webster TX",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In Webster TX",
      "h2_subtitle": "Experience the charm of Watersedge with our one bedroom apartments. Enjoy serene lake views and modern amenities designed for your comfort and style.",
      "page_copy": "Welcome to Watersedge, where our one bedroom apartments for rent in Webster TX offer a perfect blend of comfort and style. Each apartment features vaulted ceilings, oversized windows, and hardwood style flooring, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry and gleaming granite countertops, perfect for culinary enthusiasts. Relax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls and two-tone paint. \n\nOur community is designed to enhance your lifestyle with high-speed internet access, in-unit washer/dryer, and air conditioning for your convenience. Enjoy the smoke-free environment and cable-ready units, along with modern kitchen appliances like stainless steel appliances and quartz countertops. With features like walk-in closets, balconies, and patios, Watersedge offers a living experience that is both luxurious and practical.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | One Bedroom Apartments For Rent In Webster TX",
      "seo_description": "Explore Watersedge's one bedroom apartments for rent in Webster TX. Enjoy serene lake views, modern amenities, and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-webster-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Webster TX",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In Webster TX",
      "h2_subtitle": "Watersedge offers spacious two bedroom apartments with stunning lake views. Enjoy modern amenities and a vibrant community in Webster, TX.",
      "page_copy": "At Watersedge, our two bedrooms apartments for rent in Webster TX provide a perfect retreat with serene lake views and modern conveniences. Each apartment features vaulted ceilings and oversized windows, allowing natural light to fill the space. The gourmet kitchens are equipped with custom cabinetry and granite countertops, ideal for those who love to cook. Relax in your sunroom or enjoy the spacious living areas with custom accent walls and two-tone paint.\n\nOur community enhances your living experience with high-speed internet access, in-unit washer/dryer, and air conditioning. Enjoy the smoke-free environment and cable-ready units, along with modern kitchen appliances like stainless steel appliances and quartz countertops. With features like walk-in closets, balconies, and patios, Watersedge offers a luxurious and practical living experience for all residents.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Two Bedrooms Apartments For Rent In Webster TX",
      "seo_description": "Discover Watersedge's two bedrooms apartments for rent in Webster TX. Enjoy lake views, modern amenities, and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pool at Watersedge",
      "h2_subtitle": "Enjoy the luxury of a pool and other amenities at Watersedge. Discover your new home in Webster, TX, with stunning lake views and modern conveniences.",
      "page_copy": "Watersedge offers apartments for rent near me with pool access, providing a perfect blend of relaxation and recreation. Our community features a sparkling pool, ideal for unwinding after a long day or enjoying a weekend swim. Located in Webster, TX, Watersedge provides serene lake views and modern amenities, including a fitness center, dog park, and EV charging stations.\n\nOur one and two bedroom apartments feature vaulted ceilings, oversized windows, and gourmet kitchens with granite countertops. Enjoy the natural light in your sunroom or relax in spacious living areas with custom accent walls. With additional amenities like a breakfast/coffee concierge, laundry facilities, and walking/biking trails, Watersedge is designed to enhance your lifestyle and provide a vibrant community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent Near Me with Pool",
      "seo_description": "Discover Watersedge's apartments for rent near me with pool access. Enjoy modern amenities and a vibrant community in Webster, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Experience the convenience of a fitness center at Watersedge. Find your perfect home in Webster, TX, with stunning views and modern amenities.",
      "page_copy": "Watersedge offers apartments for rent near me with fitness center access, providing a convenient and healthy lifestyle. Our state-of-the-art fitness center is perfect for maintaining your workout routine without leaving the comfort of your community. Located in Webster, TX, Watersedge combines serene lake views with modern amenities, including a pool, dog park, and EV charging stations.\n\nOur one and two bedroom apartments feature vaulted ceilings, oversized windows, and gourmet kitchens with granite countertops. Enjoy the natural light in your sunroom or relax in spacious living areas with custom accent walls. With additional amenities like a breakfast/coffee concierge, laundry facilities, and walking/biking trails, Watersedge is designed to enhance your lifestyle and provide a vibrant community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Explore Watersedge's apartments for rent near me with fitness center access. Enjoy modern amenities and a vibrant community in Webster, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-dog-park",
      "search_query": "Apartments For Rent Near Me with Dog Park",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Dog Park at Watersedge",
      "h2_subtitle": "Enjoy a pet-friendly lifestyle with a dog park at Watersedge. Discover your new home in Webster, TX, with modern amenities and beautiful surroundings.",
      "page_copy": "Watersedge offers apartments for rent near me with dog park access, perfect for pet lovers seeking a welcoming community. Our dog park provides a safe and fun environment for your furry friends to play and socialize. Located in Webster, TX, Watersedge combines serene lake views with modern amenities, including a pool, fitness center, and EV charging stations.\n\nOur one and two bedroom apartments feature vaulted ceilings, oversized windows, and gourmet kitchens with granite countertops. Enjoy the natural light in your sunroom or relax in spacious living areas with custom accent walls. With additional amenities like a breakfast/coffee concierge, laundry facilities, and walking/biking trails, Watersedge is designed to enhance your lifestyle and provide a vibrant community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent Near Me with Dog Park",
      "seo_description": "Discover Watersedge's apartments for rent near me with dog park access. Enjoy modern amenities and a pet-friendly community in Webster, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-concierge",
      "search_query": "Apartments For Rent Near Me with Breakfast/Coffee Concierge",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Breakfast/Coffee Concierge",
      "h2_subtitle": "Start your day right with a breakfast/coffee concierge at Watersedge. Discover your ideal home in Webster, TX, with modern amenities and scenic views.",
      "page_copy": "Watersedge offers apartments for rent near me with breakfast/coffee concierge services, perfect for those who enjoy a convenient start to their day. Our concierge service provides a delightful morning experience, allowing you to enjoy your favorite coffee or breakfast without leaving the community. Located in Webster, TX, Watersedge combines serene lake views with modern amenities, including a pool, fitness center, and dog park.\n\nOur one and two bedroom apartments feature vaulted ceilings, oversized windows, and gourmet kitchens with granite countertops. Enjoy the natural light in your sunroom or relax in spacious living areas with custom accent walls. With additional amenities like EV charging stations, laundry facilities, and walking/biking trails, Watersedge is designed to enhance your lifestyle and provide a vibrant community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent Near Me with Breakfast/Coffee Concierge",
      "seo_description": "Discover Watersedge's apartments for rent near me with breakfast/coffee concierge. Enjoy modern amenities and a convenient lifestyle in Webster, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-ev-charging",
      "search_query": "Apartments For Rent Near Me with EV Charging",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with EV Charging at Watersedge",
      "h2_subtitle": "Enjoy the convenience of EV charging stations at Watersedge. Find your perfect home in Webster, TX, with modern amenities and beautiful surroundings.",
      "page_copy": "Watersedge offers apartments for rent near me with EV charging, ideal for eco-conscious residents seeking convenience and sustainability. Our EV charging stations ensure your electric vehicle is always ready for the road. Located in Webster, TX, Watersedge combines serene lake views with modern amenities, including a pool, fitness center, and dog park.\n\nOur one and two bedroom apartments feature vaulted ceilings, oversized windows, and gourmet kitchens with granite countertops. Enjoy the natural light in your sunroom or relax in spacious living areas with custom accent walls. With additional amenities like a breakfast/coffee concierge, laundry facilities, and walking/biking trails, Watersedge is designed to enhance your lifestyle and provide a vibrant community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent Near Me with EV Charging",
      "seo_description": "Explore Watersedge's apartments for rent near me with EV charging. Enjoy modern amenities and a sustainable lifestyle in Webster, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-floor-plan",
      "search_query": "Apartments For Rent Near Me with Floor Plan Details",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Floor Plan Details",
      "h2_subtitle": "Discover the detailed floor plans at Watersedge. Find your ideal home in Webster, TX, with modern amenities and stunning lake views.",
      "page_copy": "Watersedge offers apartments for rent near me with floor plan details that cater to your lifestyle needs. Our one and two bedroom apartments feature thoughtfully designed layouts with vaulted ceilings, oversized windows, and hardwood style flooring. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nEnjoy the natural light in your sunroom or relax in spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With additional features like a smoke-free environment and cable-ready units, Watersedge provides a comfortable and stylish living experience in Webster, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent Near Me with Floor Plan Details",
      "seo_description": "Discover Watersedge's apartments for rent near me with floor plan details. Enjoy modern amenities and a vibrant community in Webster, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-kitchen",
      "search_query": "Apartments For Rent Near Me with Kitchen Features & Appliances",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Kitchen Features & Appliances",
      "h2_subtitle": "Discover gourmet kitchens with top-notch features at Watersedge. Find your ideal home in Webster, TX, with modern amenities and stunning lake views.",
      "page_copy": "Watersedge offers apartments for rent near me with kitchen features & appliances that cater to culinary enthusiasts. Our one and two bedroom apartments boast gourmet kitchens equipped with custom cabinetry, granite countertops, and stainless steel appliances, including a microwave, range, and refrigerator. These kitchens are designed to inspire your inner chef and make meal preparation a delight.\n\nEnjoy the convenience of a pantry for extra storage and the elegance of quartz countertops. Each apartment also features vaulted ceilings, oversized windows, and hardwood style flooring, creating a bright and inviting atmosphere. With additional amenities like high-speed internet access, in-unit washer/dryer, and air conditioning, Watersedge provides a comfortable and stylish living experience in Webster, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent Near Me with Kitchen Features & Appliances",
      "seo_description": "Discover Watersedge's apartments for rent near me with kitchen features & appliances. Enjoy modern amenities and a vibrant community in Webster, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-memorial-hermann",
      "search_query": "Apartments For Rent In Webster TX Near Memorial Hermann Southeast Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near Memorial Hermann Southeast Hospital",
      "h2_subtitle": "Enjoy convenient living near Memorial Hermann Southeast Hospital at Watersedge. Discover modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near Memorial Hermann Southeast Hospital, providing a convenient location for healthcare professionals and families. Our one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nRelax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience in Webster, TX, just moments away from Memorial Hermann Southeast Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near Memorial Hermann Southeast Hospital",
      "seo_description": "Discover Watersedge's apartments for rent in Webster TX near Memorial Hermann Southeast Hospital. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-webster-tx-near-team-health",
      "search_query": "Apartments For Rent In Webster TX Near Team Health",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near Team Health",
      "h2_subtitle": "Enjoy convenient living near Team Health at Watersedge. Experience modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near Team Health, providing an ideal location for professionals seeking convenience and comfort. Our one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nRelax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience in Webster, TX, just moments away from Team Health.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near Team Health",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near Team Health. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-gastro",
      "search_query": "Apartments For Rent In Webster TX Near Gastroenterology",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near Gastroenterology",
      "h2_subtitle": "Enjoy convenient living near gastroenterology services at Watersedge. Discover modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near gastroenterology services, providing a convenient location for healthcare professionals and patients alike. Our one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nRelax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience in Webster, TX, just moments away from gastroenterology services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near Gastroenterology",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near gastroenterology services. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-webster-tx-near-hca",
      "search_query": "Apartments For Rent In Webster TX Near HCA Houston Healthcare Clear Lake",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near HCA Houston Healthcare Clear Lake",
      "h2_subtitle": "Enjoy convenient living near HCA Houston Healthcare Clear Lake at Watersedge. Experience modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near HCA Houston Healthcare Clear Lake, providing an ideal location for healthcare professionals and families. Our one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nRelax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience in Webster, TX, just moments away from HCA Houston Healthcare Clear Lake.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near HCA Houston Healthcare Clear Lake",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near HCA Houston Healthcare Clear Lake. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-houston-methodist-clear-lake-hospital",
      "search_query": "Apartments For Rent In Webster TX Near Houston Methodist Clear Lake Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near Houston Methodist Clear Lake Hospital",
      "h2_subtitle": "Enjoy convenient living near Houston Methodist Clear Lake Hospital at Watersedge. Discover modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near Houston Methodist Clear Lake Hospital, providing a convenient location for healthcare professionals and patients. Our one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nRelax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience in Webster, TX, just moments away from Houston Methodist Clear Lake Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near Houston Methodist Clear Lake Hospital",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near Houston Methodist Clear Lake Hospital. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-webster-tx-near-san-jacinto-college",
      "search_query": "Apartments For Rent In Webster TX Near San Jacinto College: Central Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near San Jacinto College: Central Campus",
      "h2_subtitle": "Enjoy convenient living near San Jacinto College: Central Campus at Watersedge. Experience modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near San Jacinto College: Central Campus, providing an ideal location for students and faculty. Our one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nRelax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience in Webster, TX, just moments away from San Jacinto College: Central Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near San Jacinto College: Central Campus",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near San Jacinto College: Central Campus. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-u-of-houston-clear-lake",
      "search_query": "Apartments For Rent In Webster TX Near University of Houston-Clear Lake",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near University of Houston-Clear Lake",
      "h2_subtitle": "Enjoy convenient living near University of Houston-Clear Lake at Watersedge. Discover modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near University of Houston-Clear Lake, providing an ideal location for students and faculty. Our one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nRelax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience in Webster, TX, just moments away from University of Houston-Clear Lake.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near University of Houston-Clear Lake",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near University of Houston-Clear Lake. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-remington-college",
      "search_query": "Apartments For Rent In Webster TX Near Remington College - North Houston Satellite Location",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near Remington College - North Houston Satellite Location",
      "h2_subtitle": "Enjoy convenient living near Remington College's North Houston Satellite Location at Watersedge. Discover modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near Remington College - North Houston Satellite Location, providing an ideal setting for students and professionals seeking career-focused education. Our one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nRelax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience in Webster, TX, just moments away from Remington College's North Houston Satellite Location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near Remington College - North Houston Satellite Location",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near Remington College - North Houston Satellite Location. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-webster-tx-near-alvin-community",
      "search_query": "Apartments For Rent In Webster TX Near Alvin Community College",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near Alvin Community College",
      "h2_subtitle": "Enjoy convenient living near Alvin Community College at Watersedge. Experience modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near Alvin Community College, providing an ideal location for students and faculty. Our one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for culinary enthusiasts.\n\nRelax in your sunroom filled with natural light or enjoy the spacious living areas with custom accent walls. Each apartment includes walk-in closets, a balcony or patio, and modern conveniences like high-speed internet access, in-unit washer/dryer, and air conditioning. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience in Webster, TX, just moments away from Alvin Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near Alvin Community College",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near Alvin Community College. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-in-webster-tx-near-greene-school",
      "search_query": "Apartments For Rent In Webster TX Near Greene Elementary School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Webster TX Near Greene Elementary School",
      "h2_subtitle": "Enjoy family-friendly living near Greene Elementary School at Watersedge. Discover modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near Greene Elementary School, making it an ideal choice for families seeking quality education within close proximity. Located just 4.2 km from the school, our community provides convenient access to the Allen Independent School District, known for cultivating individuality and inspiring students to discover their unique talents.\n\nOur one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for family meals. Enjoy the spacious living areas with custom accent walls and a sunroom filled with natural light. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience for families in Webster, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near Greene Elementary School",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near Greene Elementary School. Enjoy modern amenities and a family-friendly location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5198384616964096",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-webster-tx-near-clear-brook-high",
      "search_query": "Apartments For Rent In Webster TX Near Clear Brook High School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Webster TX Near Clear Brook High School",
      "h2_subtitle": "Enjoy family-friendly living near Clear Brook High School at Watersedge. Experience modern amenities and serene lake views in Webster, TX.",
      "page_copy": "Watersedge offers apartments for rent in Webster TX near Clear Brook High School, making it an ideal choice for families seeking quality education within the Clear Creek Independent School District. Located just 7.4 km from the school, our community provides convenient access for students and parents alike.\n\nOur one and two bedroom apartments feature serene lake views, vaulted ceilings, and oversized windows, creating a bright and inviting atmosphere. The gourmet kitchens are equipped with custom cabinetry, granite countertops, and stainless steel appliances, perfect for family meals. Enjoy the spacious living areas with custom accent walls and a sunroom filled with natural light. With community amenities such as a fitness center, pool, and dog park, Watersedge offers a vibrant and comfortable living experience for families in Webster, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
      "featured_image_media": {
        "alt_text": "The exterior of the Emerson Park apartment building entrance with landscaped bushes and flowers.",
        "public_id": "019f6c14-1894-70de-82e6-35537425edf1",
        "storage_key": "property/5198384616964096/019f6c14-1894-70de-82e6-35537425edf1.webp",
        "width": 1504,
        "height": 853
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
      "blank_image_media": {
        "alt_text": "Exterior building view of a multifamily property",
        "public_id": "019f6c14-2127-7517-ae1c-4d1033d0caf4",
        "storage_key": "property/5198384616964096/019f6c14-2127-7517-ae1c-4d1033d0caf4.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Watersedge FKA The Reagan | Apartments For Rent In Webster TX Near Clear Brook High School",
      "seo_description": "Explore Watersedge's apartments for rent in Webster TX near Clear Brook High School. Enjoy modern amenities and a family-friendly location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2605"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "3391742509"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a6c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a6c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5056167"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MHG8VWK"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "4"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "9835702688"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "5cc0ec11f1fd09c9"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/910pdmzyp2z"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/61befdce-7db3-4f81-b4a1-541a1352f444"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "832-621-3396"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBoY29NVWhyaWIyQlNncGdaWG1NNFE9PSIsInZhbHVlIjoiUFJVVk1hdUhhNWFsa3BZN29lbGhTZz09IiwibWFjIjoiNDZhOTQ4MWNhN2U5Y2M1MmJmMjM0OTI5MjE3ZWJlZTYyOGEyZDcxODhkZTgzNzc4NTM5NzFiZjliOGI3YmZmYyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2605",
  "custom_repli_id": "3391742509",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a6c\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a6c\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5056167",
  "custom_google_gtm_id": "GTM-MHG8VWK",
  "custom_rollout_phase": "4",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "9835702688",
  "custom_knock_community_id": "5cc0ec11f1fd09c9",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/910pdmzyp2z",
  "custom_self_guided_tour_url": "https://selftournow.com/property/61befdce-7db3-4f81-b4a1-541a1352f444",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "832-621-3396",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBoY29NVWhyaWIyQlNncGdaWG1NNFE9PSIsInZhbHVlIjoiUFJVVk1hdUhhNWFsa3BZN29lbGhTZz09IiwibWFjIjoiNDZhOTQ4MWNhN2U5Y2M1MmJmMjM0OTI5MjE3ZWJlZTYyOGEyZDcxODhkZTgzNzc4NTM5NzFiZjliOGI3YmZmYyJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "1eb67ef7-be65-4646-89bd-580a8658f0a9",
  "custom_audioeye_site_hash": "e1a7fd8ec2a537dcfe367877a3aa74ae"
};

export const generatedAt = '2026-11-03T20:27:31.097Z';
